/* Everhem theme JS entrypoint */
/* jQuery-first by design. Keep it simple. */

window.EverhemTheme = window.EverhemTheme || {};

(function ($, window, document) {
  'use strict';

  var ACCOUNT_AUTH_STORAGE_KEY = 'everhem_customer_account_tokens';
  var ACCOUNT_AUTH_STATE_KEY = 'everhem_customer_account_auth_state';
  var ACCOUNT_AUTH_CALLBACK_PATH = '/pages/account-auth-callback';
  var ACCOUNT_DASHBOARD_PATH = '/pages/account-dashboard';
  var ACCOUNT_SCOPE = 'openid email customer-account-api:full';
  var EVERHEM_ANALYTICS_EVENTS = {
    productAddToCart: 'everhem_add_to_cart',
    swatchAddToCart: 'everhem_swatch_add_to_cart',
    startedOrder: 'everhem_started_order',
  };

  function trimTrailingSlash(value) {
    return (value || '').replace(/\/$/, '');
  }

  function formatCurrency(value) {
    var number = Number(value);

    if (Number.isNaN(number)) {
      return value;
    }

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(number);
  }

  function formatDate(value) {
    if (!value) return '';

    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeAnalyticsValue(value) {
    if (value == null) return '';
    return String(value).trim();
  }

  function normalizeAnalyticsToken(value) {
    var normalized = normalizeAnalyticsValue(value);
    if (!normalized) return '';

    try {
      normalized = decodeURIComponent(normalized);
    } catch (error) {}

    return normalized
      .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  function normalizeAnalyticsNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function centsToAnalyticsValue(cents) {
    var number = normalizeAnalyticsNumber(cents, 0);
    return Math.round(number) / 100;
  }

  function getDatasetValue(node, key) {
    if (!node || !node.dataset) return '';
    return normalizeAnalyticsValue(node.dataset[key]);
  }

  function getProductFormDatasetValue(form, key) {
    return getDatasetValue(form, key) || getDatasetValue(form ? form.querySelector('[data-product-analytics]') : null, key);
  }

  function getFormValue(form, name) {
    if (!form) return '';
    var field = form.querySelector('[name="' + name.replace(/"/g, '\\"') + '"]');
    if (!field) return '';

    if (field.type === 'radio' || field.type === 'checkbox') {
      var checked = form.querySelector('[name="' + name.replace(/"/g, '\\"') + '"]:checked');
      return checked ? normalizeAnalyticsValue(checked.value) : '';
    }

    return normalizeAnalyticsValue(field.value);
  }

  function pushDataLayerEvent(eventName, payload) {
    var eventPayload = Object.assign({ event: eventName }, payload || {});

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventPayload);

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload || {});
    }

    if (window.analytics && typeof window.analytics.track === 'function') {
      window.analytics.track(eventName, payload || {});
    }
  }

  function emitEverhemCommerceEvent(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    pushDataLayerEvent(eventName, payload);
  }

  function getMetaContents(ecommerce) {
    return (ecommerce && ecommerce.items ? ecommerce.items : []).map(function (item) {
      return {
        id: normalizeAnalyticsValue(item.item_id || item.sku),
        quantity: Math.max(1, normalizeAnalyticsNumber(item.quantity, 1)),
        item_price: normalizeAnalyticsNumber(item.price, 0),
      };
    }).filter(function (item) {
      return item.id;
    });
  }

  function buildMetaParams(ecommerce, extra) {
    var contents = getMetaContents(ecommerce);
    var firstItem = ecommerce && ecommerce.items && ecommerce.items.length ? ecommerce.items[0] : {};

    return Object.assign({}, extra || {}, {
      content_ids: contents.map(function (item) { return item.id; }),
      content_type: 'product',
      contents: contents,
      currency: ecommerce && ecommerce.currency ? ecommerce.currency : 'USD',
      value: ecommerce && ecommerce.value != null ? ecommerce.value : 0,
      product_type: firstItem.item_category || '',
      product_type_label: firstItem.item_category_label || firstItem.item_category || '',
      sku: firstItem.sku || '',
      fabric: firstItem.fabric || '',
      fabric_sku: firstItem.fabric_sku || '',
    });
  }

  function pushMetaPixelEvent(method, eventName, params) {
    if (typeof window.fbq !== 'function') return;
    window.fbq(method, eventName, params || {});
  }

  function getEverhemAddToCartEventName(kind) {
    return kind === 'swatch'
      ? EVERHEM_ANALYTICS_EVENTS.swatchAddToCart
      : EVERHEM_ANALYTICS_EVENTS.productAddToCart;
  }

  function getEverhemCartType(ecommerce) {
    var items = ecommerce && ecommerce.items ? ecommerce.items : [];
    var hasSwatch = false;
    var hasProduct = false;

    items.forEach(function (item) {
      var category = normalizeAnalyticsToken(item.item_category);

      if (category === 'swatch') {
        hasSwatch = true;
      } else {
        hasProduct = true;
      }
    });

    if (hasSwatch && hasProduct) return 'mixed';
    if (hasSwatch) return 'swatch';
    if (hasProduct) return 'product';
    return '';
  }

  function normalizeAnalyticsItem(item) {
    item = item || {};
    var itemCategoryLabel = normalizeAnalyticsValue(item.item_category || item.product_type || item.productType);

    return {
      item_id: normalizeAnalyticsValue(item.item_id || item.variant_id || item.id),
      item_name: normalizeAnalyticsValue(item.item_name || item.product_title || item.title),
      item_variant: normalizeAnalyticsValue(item.item_variant || item.variant_title),
      item_category: normalizeAnalyticsToken(itemCategoryLabel),
      item_category_label: itemCategoryLabel,
      price: normalizeAnalyticsNumber(item.price, 0),
      quantity: Math.max(1, normalizeAnalyticsNumber(item.quantity, 1)),
      sku: normalizeAnalyticsValue(item.sku),
      fabric: normalizeAnalyticsValue(item.fabric),
      fabric_sku: normalizeAnalyticsValue(item.fabric_sku || item.fabricSku),
    };
  }

  function buildCartItemAnalyticsPayload(item, fallback) {
    item = item || {};
    fallback = fallback || {};

    var properties = item.properties || {};
    var quantity = normalizeAnalyticsNumber(item.quantity, fallback.quantity || 1);
    var priceCents = item.final_price != null ? item.final_price : item.price;
    var analyticsItem = normalizeAnalyticsItem({
      item_id: item.variant_id || fallback.variantId,
      item_name: item.product_title || item.title || fallback.title,
      item_variant: item.variant_title || fallback.variantTitle,
      item_category: item.product_type || fallback.productType,
      price: priceCents != null ? centsToAnalyticsValue(priceCents) : fallback.price,
      quantity: quantity,
      sku: item.sku || fallback.sku,
      fabric: properties.Fabric || fallback.fabric,
      fabric_sku: properties['Fabric SKU'] || fallback.fabricSku,
    });

    return {
      currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'USD',
      value: Math.round(analyticsItem.price * analyticsItem.quantity * 100) / 100,
      items: [analyticsItem],
    };
  }

  function buildProductFormAnalyticsFallback(form) {
    var quantity = normalizeAnalyticsNumber(getFormValue(form, 'quantity'), 1);
    var variantId = getFormValue(form, 'id') || getProductFormDatasetValue(form, 'variantId');

    return {
      variantId: variantId,
      title: getProductFormDatasetValue(form, 'productTitle'),
      productType: getProductFormDatasetValue(form, 'productType'),
      price: centsToAnalyticsValue(getProductFormDatasetValue(form, 'price')),
      quantity: quantity,
      sku: getProductFormDatasetValue(form, 'variantSku'),
      fabric: getFormValue(form, 'properties[Fabric]'),
      fabricSku: getFormValue(form, 'properties[Fabric SKU]'),
    };
  }

  function trackAddToCart(kind, itemPayload, extra) {
    var ecommerce = buildCartItemAnalyticsPayload(itemPayload, extra);
    var firstItem = ecommerce.items[0] || {};
    var customPayload = Object.assign({}, extra || {}, {
      ecommerce: ecommerce,
      product_type: firstItem.item_category,
      product_type_label: firstItem.item_category_label || firstItem.item_category,
      fabric: firstItem.fabric,
      fabric_sku: firstItem.fabric_sku,
      sku: firstItem.sku,
    });

    emitEverhemCommerceEvent('add_to_cart', ecommerce);
    emitEverhemCommerceEvent(getEverhemAddToCartEventName(kind), customPayload);
    pushMetaPixelEvent('track', 'AddToCart', buildMetaParams(ecommerce, customPayload));
    pushMetaPixelEvent('trackCustom', getEverhemAddToCartEventName(kind), buildMetaParams(ecommerce, customPayload));
  }

  function trackAddToCartBatch(kind, items, extra) {
    items = Array.isArray(items) ? items : [];
    if (!items.length) return;

    var ecommerceItems = items.map(function (item) {
      return buildCartItemAnalyticsPayload(item, extra).items[0];
    }).filter(Boolean);
    var value = ecommerceItems.reduce(function (sum, item) {
      return sum + (normalizeAnalyticsNumber(item.price, 0) * normalizeAnalyticsNumber(item.quantity, 1));
    }, 0);
    var ecommerce = {
      currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'USD',
      value: Math.round(value * 100) / 100,
      items: ecommerceItems,
    };
    var productTypes = ecommerceItems.map(function (item) {
      return item.item_category;
    }).filter(Boolean);

    emitEverhemCommerceEvent('add_to_cart', ecommerce);
    var customPayload = Object.assign({}, extra || {}, {
      ecommerce: ecommerce,
      product_type: productTypes.length ? productTypes.join(', ') : '',
    });
    emitEverhemCommerceEvent(getEverhemAddToCartEventName(kind), customPayload);
    pushMetaPixelEvent('track', 'AddToCart', buildMetaParams(ecommerce, customPayload));
    pushMetaPixelEvent('trackCustom', getEverhemAddToCartEventName(kind), buildMetaParams(ecommerce, customPayload));
  }

  function buildCartAnalyticsPayload(cart) {
    var items = (cart && cart.items ? cart.items : []).map(function (item) {
      return normalizeAnalyticsItem({
        item_id: item.variant_id,
        item_name: item.product_title || item.title,
        item_variant: item.variant_title,
        item_category: item.product_type,
        price: centsToAnalyticsValue(item.final_price != null ? item.final_price : item.price),
        quantity: item.quantity,
        sku: item.sku,
        fabric: item.properties && item.properties.Fabric,
        fabric_sku: item.properties && item.properties['Fabric SKU'],
      });
    });
    var value = items.reduce(function (sum, item) {
      return sum + (normalizeAnalyticsNumber(item.price, 0) * normalizeAnalyticsNumber(item.quantity, 1));
    }, 0);

    return {
      currency: cart && cart.currency ? cart.currency : (window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'USD'),
      value: Math.round(value * 100) / 100,
      items: items,
    };
  }

  function trackBeginCheckout(cart) {
    var ecommerce = buildCartAnalyticsPayload(cart);
    var customPayload = {
      ecommerce: ecommerce,
      cart_type: getEverhemCartType(ecommerce),
    };

    emitEverhemCommerceEvent('begin_checkout', ecommerce);
    emitEverhemCommerceEvent(EVERHEM_ANALYTICS_EVENTS.startedOrder, customPayload);
    pushMetaPixelEvent('track', 'InitiateCheckout', buildMetaParams(ecommerce, customPayload));
    pushMetaPixelEvent('trackCustom', EVERHEM_ANALYTICS_EVENTS.startedOrder, buildMetaParams(ecommerce, customPayload));
  }

  function buildApiUrl(baseUrl, path) {
    return trimTrailingSlash(baseUrl) + path;
  }

  function getAccountBackendBaseUrl() {
    return trimTrailingSlash(window.EverhemTheme.accountBackendBaseUrl || 'https://everhem-staging-backend.azurewebsites.net');
  }

  function getStoreOrigin() {
    return window.location.origin;
  }

  function randomString(length) {
    var bytes = new Uint8Array(length);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes).map(function (byte) {
      return (byte % 36).toString(36);
    }).join('');
  }

  function base64UrlEncode(bytes) {
    var binary = '';
    bytes.forEach(function (byte) {
      binary += String.fromCharCode(byte);
    });

    return window.btoa(binary)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/g, '');
  }

  async function sha256(value) {
    var encoded = new TextEncoder().encode(value);
    var digest = await window.crypto.subtle.digest('SHA-256', encoded);
    return new Uint8Array(digest);
  }

  function getStoredTokens() {
    try {
      var raw = window.localStorage.getItem(ACCOUNT_AUTH_STORAGE_KEY);
      if (!raw) return null;

      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') {
        return null;
      }

      return parsed;
    } catch (_error) {
      return null;
    }
  }

  function setStoredTokens(tokens) {
    window.localStorage.setItem(ACCOUNT_AUTH_STORAGE_KEY, JSON.stringify(tokens));
  }

  function normalizeStoredTokens(tokens) {
    if (!tokens || typeof tokens !== 'object') {
      return null;
    }

    if (!tokens.accessToken || !tokens.expiresAt) {
      return null;
    }

    return {
      accessToken: String(tokens.accessToken),
      refreshToken: tokens.refreshToken ? String(tokens.refreshToken) : '',
      idToken: tokens.idToken ? String(tokens.idToken) : '',
      expiresAt: Number(tokens.expiresAt) || 0,
      tokenType: tokens.tokenType ? String(tokens.tokenType) : 'Bearer',
      scope: tokens.scope ? String(tokens.scope) : ACCOUNT_SCOPE,
    };
  }

  function getStoredAuthState() {
    try {
      var raw = window.sessionStorage.getItem(ACCOUNT_AUTH_STATE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (_error) {
      return null;
    }
  }

  function clearStoredTokens() {
    window.localStorage.removeItem(ACCOUNT_AUTH_STORAGE_KEY);
  }

  function setStoredAuthState(payload) {
    window.sessionStorage.setItem(ACCOUNT_AUTH_STATE_KEY, JSON.stringify(payload));
  }

  function clearStoredAuthState() {
    window.sessionStorage.removeItem(ACCOUNT_AUTH_STATE_KEY);
  }

  function getTokenExpiryStatus() {
    var tokens = normalizeStoredTokens(getStoredTokens());
    if (!tokens) {
      console.log('[everhem account] token expiry check: missing token');
      return 'missing';
    }

    if (!tokens.expiresAt || Number.isNaN(tokens.expiresAt)) {
      console.log('[everhem account] token expiry check: invalid expiry', tokens);
      return 'invalid';
    }

    if (Date.now() >= (tokens.expiresAt - 60000)) {
      console.log('[everhem account] token expiry check: expired', {
        now: Date.now(),
        expiresAt: tokens.expiresAt,
      });
      return 'expired';
    }

    console.log('[everhem account] token expiry check: valid', {
      now: Date.now(),
      expiresAt: tokens.expiresAt,
      tokenType: tokens.tokenType,
      scope: tokens.scope,
    });
    return 'valid';
  }

  function hasValidToken() {
    return getTokenExpiryStatus() === 'valid';
  }

  function getUsableAccessToken() {
    var tokens = normalizeStoredTokens(getStoredTokens());
    if (!tokens) {
      return null;
    }

    if (getTokenExpiryStatus() !== 'valid') {
      return null;
    }

    return tokens.accessToken;
  }

  async function discoverCustomerAccountConfig() {
    var storeOrigin = getStoreOrigin();
    var response = await fetch(storeOrigin + '/.well-known/openid-configuration');

    if (!response.ok) {
      throw new Error('Failed to load Shopify OpenID configuration');
    }

    var config = await response.json();
    return {
      authorizationEndpoint: config.authorization_endpoint,
      tokenEndpoint: config.token_endpoint,
      endSessionEndpoint: config.end_session_endpoint,
      issuer: config.issuer,
    };
  }

  async function beginCustomerAccountAuth() {
    if (!window.EverhemTheme.customerAccountClientId) {
      throw new Error('Missing customer account client id');
    }

    var config = await discoverCustomerAccountConfig();
    var state = randomString(32);
    var nonce = randomString(32);
    var codeVerifier = randomString(64);
    var codeChallenge = base64UrlEncode(await sha256(codeVerifier));
    var redirectUri = getStoreOrigin() + ACCOUNT_AUTH_CALLBACK_PATH;
    var url = new URL(config.authorizationEndpoint);

    url.searchParams.set('client_id', window.EverhemTheme.customerAccountClientId);
    url.searchParams.set('scope', ACCOUNT_SCOPE);
    url.searchParams.set('response_type', 'code');
    url.searchParams.set('redirect_uri', redirectUri);
    url.searchParams.set('state', state);
    url.searchParams.set('nonce', nonce);
    url.searchParams.set('code_challenge', codeChallenge);
    url.searchParams.set('code_challenge_method', 'S256');

    setStoredAuthState({
      state: state,
      nonce: nonce,
      codeVerifier: codeVerifier,
      redirectUri: redirectUri,
      startedAt: Date.now(),
    });

    window.location.href = url.toString();
  }

  async function exchangeCustomerAccountCode(params) {
    var storedState = getStoredAuthState();
    if (!storedState || storedState.state !== params.get('state')) {
      throw new Error('Customer account auth state mismatch');
    }

    if (!params.get('code')) {
      throw new Error('Missing customer account authorization code');
    }

    var config = await discoverCustomerAccountConfig();
    var body = new URLSearchParams();
    body.set('grant_type', 'authorization_code');
    body.set('client_id', window.EverhemTheme.customerAccountClientId || '');
    body.set('redirect_uri', storedState.redirectUri);
    body.set('code', params.get('code') || '');
    body.set('code_verifier', storedState.codeVerifier);

    var response = await fetch(config.tokenEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: body.toString(),
    });

    if (!response.ok) {
      throw new Error('Failed to exchange customer account code');
    }

    var payload = await response.json();
    setStoredTokens({
      accessToken: payload.access_token,
      refreshToken: payload.refresh_token,
      idToken: payload.id_token,
      expiresAt: Date.now() + ((payload.expires_in || 0) * 1000),
      tokenType: payload.token_type || 'Bearer',
      scope: payload.scope || ACCOUNT_SCOPE,
    });
    clearStoredAuthState();
    window.location.replace(ACCOUNT_DASHBOARD_PATH);
  }

  async function ensureCustomerAccountToken(options) {
    var settings = options || {};
    var expiryStatus = getTokenExpiryStatus();

    console.log('[everhem account] ensure token start', {
      pathname: window.location.pathname,
      requireAuth: !!settings.requireAuth,
      expiryStatus: expiryStatus,
      hasStoredToken: !!getStoredTokens(),
      hasStoredAuthState: !!getStoredAuthState(),
    });

    if (expiryStatus === 'valid') {
      console.log('[everhem account] ensure token returning usable access token');
      return getUsableAccessToken();
    }

    if (expiryStatus === 'expired' || expiryStatus === 'invalid') {
      console.log('[everhem account] ensure token clearing stale token state', {
        expiryStatus: expiryStatus,
      });
      clearStoredTokens();
    }

    if (window.location.pathname === ACCOUNT_AUTH_CALLBACK_PATH) {
      var params = new URLSearchParams(window.location.search);
      if (params.get('code')) {
        console.log('[everhem account] ensure token detected callback code, exchanging');
        await exchangeCustomerAccountCode(params);
        return null;
      }
    }

    if (settings.requireAuth) {
      console.log('[everhem account] ensure token throwing requireAuth failure', {
        expiryStatus: expiryStatus,
      });
      throw new Error(expiryStatus === 'expired'
        ? 'Customer account token expired, sign in again.'
        : 'No usable Shopify customer token found.');
    }

    console.log('[everhem account] ensure token returning null without requireAuth');
    return null;
  }

  function setCallbackState(title, body, isError) {
    var $callback = $('[data-account-auth-callback-state]');
    if (!$callback.length) return;

    $callback.prop('hidden', false).toggleClass('is-error', !!isError);
    $callback.find('[data-account-auth-callback-title]').text(title || 'Finishing sign-in…');
    $callback.find('[data-account-auth-callback-body]').text(body || 'Hang tight while we connect your Shopify customer account.');
  }

  function hideCallbackState() {
    var $callback = $('[data-account-auth-callback-state]');
    if (!$callback.length) return;
    $callback.prop('hidden', true).removeClass('is-error');
  }

  function bindAccountAuthStart() {
    $('[data-account-auth-start]').on('click', function () {
      beginCustomerAccountAuth().catch(function (error) {
        console.error('[everhem account] failed to start customer auth', error);
        setCallbackState('Could not start sign-in', error && error.message ? error.message : 'We could not start the Shopify customer account flow. Try again in a second.', true);
        var $dashboardErrors = $('[data-account-errors]');
        if ($dashboardErrors.length) {
          $dashboardErrors.text(error && error.message ? error.message : 'Could not start Shopify customer account sign-in.').prop('hidden', false);
        }
      });
    });

    $('[data-account-auth-reset]').on('click', function () {
      clearStoredTokens();
      clearStoredAuthState();
      hideCallbackState();
      window.location.href = ACCOUNT_DASHBOARD_PATH;
    });
  }

  function renderEmptyState($container, message) {
    $container.html('<p class="everhem-account-dashboard__empty">' + escapeHtml(message) + '</p>');
  }

  function unwrapJqueryResponse(response) {
    return Array.isArray(response) ? (response[0] || {}) : (response || {});
  }

  function classifyAccountError(xhr, fallbackMessage) {
    var status = xhr && xhr.status;
    var backendMessage = xhr && xhr.responseJSON && xhr.responseJSON.message;

    if (status === 401) {
      return {
        type: 'unauthenticated',
        message: backendMessage || 'Sign in to load your Everhem account.',
      };
    }

    if (status === 404) {
      return {
        type: 'not_found',
        message: backendMessage || fallbackMessage || 'We could not find that account data.',
      };
    }

    return {
      type: 'error',
      message: backendMessage || fallbackMessage || 'We hit a snag loading your Everhem account data.',
    };
  }

  function parseJsonResponse(response, fallbackMessage) {
    if (!response.ok) {
      return response.json().catch(function () {
        return {};
      }).then(function (payload) {
        var message = payload && (payload.description || payload.message) ? (payload.description || payload.message) : fallbackMessage;
        var error = new Error(message || 'Request failed');
        error.response = payload;
        throw error;
      });
    }

    return response.json();
  }

  function addNativeCartBatch(batch) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: (batch && batch.items) || []
      })
    }).then(function (response) {
      return parseJsonResponse(response, 'Cart add failed');
    });
  }

  function fetchCart() {
    return fetch('/cart.js', {
      headers: {
        'Accept': 'application/json'
      }
    }).then(function (response) {
      return parseJsonResponse(response, 'Failed to load cart');
    });
  }

  function addToCart(payload) {
    var headers = {
      'Accept': 'application/json'
    };
    var body = payload;
    var isFormData = typeof window !== 'undefined' && window.FormData && payload instanceof window.FormData;

    if (!isFormData) {
      headers['Content-Type'] = 'application/json';
      body = typeof payload === 'string' ? payload : JSON.stringify(payload || {});
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: headers,
      body: body
    }).then(function (response) {
      return parseJsonResponse(response, 'Failed to add item to cart');
    });
  }

  function fetchJson(baseUrl, path, token) {
    var url = buildApiUrl(baseUrl, path);
    console.log('[everhem account] GET', {
      url: url,
      withCredentials: true,
      hasBearerToken: !!token,
      currentOrigin: window.location.origin,
    });

    return $.ajax({
      url: buildApiUrl(baseUrl, path),
      method: 'GET',
      xhrFields: { withCredentials: true },
      headers: token ? { Authorization: 'Bearer ' + token } : undefined,
    });
  }

  function fetchJsonAuthed(baseUrl, path) {
    return ensureCustomerAccountToken({ requireAuth: true }).then(function (token) {
      return fetchJson(baseUrl, path, token);
    });
  }

  function postJson(baseUrl, path, data, token) {
    var url = buildApiUrl(baseUrl, path);
    console.log('[everhem account] POST', {
      url: url,
      withCredentials: true,
      hasBearerToken: !!token,
      currentOrigin: window.location.origin,
      payload: data || {},
    });

    return $.ajax({
      url: buildApiUrl(baseUrl, path),
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(data || {}),
      xhrFields: { withCredentials: true },
      headers: token ? { Authorization: 'Bearer ' + token } : undefined,
    });
  }

  function postJsonAuthed(baseUrl, path, data) {
    return ensureCustomerAccountToken({ requireAuth: true }).then(function (token) {
      return postJson(baseUrl, path, data, token);
    });
  }

  var tradeMembershipPromise = null;

  function setResolvedTradeMember(value, source) {
    window.EverhemTheme.settings = window.EverhemTheme.settings || {};
    window.EverhemTheme.settings.isTradeMember = !!value;
    window.EverhemTheme.settings.tradeMemberSource = source || 'unknown';
    return window.EverhemTheme.settings.isTradeMember;
  }

  function resolveTradeMembership() {
    if (isTradeMember()) {
      return Promise.resolve(true);
    }

    if (tradeMembershipPromise) {
      return tradeMembershipPromise;
    }

    var token = getUsableAccessToken();
    if (!token) {
      return Promise.resolve(false);
    }

    tradeMembershipPromise = fetchJson(getAccountBackendBaseUrl(), '/api/account', token)
      .then(function (account) {
        return setResolvedTradeMember(!!(account && account.isTradeProfessional), 'backend');
      })
      .catch(function (error) {
        console.warn('[everhem cart] could not resolve backend trade membership', error);
        return isTradeMember();
      });

    return tradeMembershipPromise;
  }

  function quoteStatusClass(status) {
    return 'everhem-account-dashboard__status--' + escapeHtml((status || 'draft').toLowerCase());
  }

  function orderStatusClass(status) {
    return 'everhem-account-dashboard__status--order-' + escapeHtml((status || 'processing').toLowerCase().replace(/[^a-z0-9]+/g, '-'));
  }

  function getOrderStatusLabel(order) {
    return order.displayFulfillmentStatus || order.fulfillmentStatus || order.financialStatus || order.status || 'Processing';
  }

  function renderOrderRows(detail) {
    var rows = [
      ['Order number', detail.orderNumber || ''],
      ['Purchase date', formatDate(detail.purchaseDate)],
      ['Subtotal', detail.subTotalText || formatCurrency(detail.subTotal || 0)],
      ['Discount', detail.discountAmountText || formatCurrency(detail.discountAmount || 0)],
      ['Shipping', detail.shippingCostText || formatCurrency(detail.shippingCost || 0)],
      ['Tax', detail.taxAmountText || formatCurrency(detail.taxAmount || 0)],
      ['Total', detail.totalCostText || formatCurrency(detail.totalCost || 0)],
      ['Ship to', detail.shippingAddress || ''],
    ].filter(function (row) {
      return row[1];
    });

    return rows.map(function (row) {
      return '<div class="everhem-account-dashboard__detail-row"><dt>' + escapeHtml(row[0]) + '</dt><dd>' + escapeHtml(row[1]) + '</dd></div>';
    }).join('');
  }

  function renderOrderItems(detail) {
    if (!detail.items || !detail.items.length) {
      return '<div class="everhem-account-dashboard__detail-card"><p class="everhem-account-dashboard__empty">No line items found.</p></div>';
    }

    return detail.items.map(function (item) {
      var isSwatch = (item.type || '').toLowerCase() === 'swatch';
      var config = isSwatch ? '' : (item.configurationDetails || []).map(function (entry) {
        return '<li>' + escapeHtml(entry.label) + ': ' + escapeHtml(entry.content || '') + '</li>';
      }).join('');

      return [
        '<div class="everhem-account-dashboard__line-item everhem-account-dashboard__line-item--order">',
        item.imageUrl
          ? '<img class="everhem-account-dashboard__line-item-media" src="' + escapeHtml(item.imageUrl) + '" alt="" aria-hidden="true" loading="lazy">'
          : '<div class="everhem-account-dashboard__line-item-media" aria-hidden="true"></div>',
        '<div class="everhem-account-dashboard__line-item-body">',
        '<div class="everhem-account-dashboard__detail-card-header">',
        '<div>',
        '<p class="everhem-account-dashboard__line-item-kicker">', escapeHtml(item.type || 'Custom order'), '</p>',
        '<h4 class="everhem-account-dashboard__line-item-title">', escapeHtml(item.label || item.name || 'Order item'), '</h4>',
        '<span class="everhem-account-dashboard__line-item-meta">Qty ', escapeHtml(item.quantity || ''), ' • ', escapeHtml(item.totalText || item.costText || ''), '</span>',
        '</div>',
        '</div>',
        item.description ? '<p class="everhem-account-dashboard__line-item-copy">' + escapeHtml(item.description) + '</p>' : '',
        config ? '<ul class="everhem-account-dashboard__config-list">' + config + '</ul>' : '',
        '</div>',
        '</div>'
      ].join('');
    }).join('');
  }

  function renderQuoteRows(detail) {
    var rows = [
      ['Quote name', detail.name || ''],
      ['Status', detail.status || ''],
      ['Created', formatDate(detail.createdAt)],
      ['Total', formatCurrency(detail.cost || 0)],
      ['Discount', detail.discount ? formatCurrency(detail.discount) : ''],
      ['Notes', detail.notes || ''],
      ['Customer notes', detail.customerNotes || ''],
    ].filter(function (row) {
      return row[1];
    });

    return rows.map(function (row) {
      return '<div class="everhem-account-dashboard__detail-row"><dt>' + escapeHtml(row[0]) + '</dt><dd>' + escapeHtml(row[1]) + '</dd></div>';
    }).join('');
  }

  function renderQuoteItems(detail) {
    if (!detail.products || !detail.products.length) {
      return '<div class="everhem-account-dashboard__detail-card"><p class="everhem-account-dashboard__empty">No quote products found.</p></div>';
    }

    return detail.products.map(function (product) {
      var params = (product.displayParams || []).filter(function (entry) {
        return entry && entry.value;
      }).map(function (entry) {
        return '<li>' + escapeHtml(entry.key) + ': ' + escapeHtml(entry.value) + '</li>';
      }).join('');

      return [
        '<div class="everhem-account-dashboard__line-item">',
        '<div class="everhem-account-dashboard__detail-card-header">',
        '<div>',
        '<h4 class="everhem-account-dashboard__line-item-title">', escapeHtml(product.label || product.type || 'Quote item'), '</h4>',
        '<span class="everhem-account-dashboard__line-item-meta">Qty ', escapeHtml(product.quantity || ''), ' • ', formatCurrency(product.cost || 0), '</span>',
        '</div>',
        '</div>',
        params ? '<ul class="everhem-account-dashboard__config-list">' + params + '</ul>' : '',
        '</div>'
      ].join('');
    }).join('');
  }

  function bindAccountDashboardTabs($dashboard) {
    var $triggers = $dashboard.find('[data-account-tab-trigger]');
    var $panels = $dashboard.find('[data-account-tab-panel]');

    $triggers.on('click', function () {
      var $trigger = $(this);
      var target = $trigger.attr('data-target-tab');

      $triggers.removeClass('is-active').attr('aria-pressed', 'false');
      $trigger.addClass('is-active').attr('aria-pressed', 'true');

      $panels.each(function () {
        var $panel = $(this);
        var isMatch = $panel.attr('data-account-tab-panel') === target;
        $panel.toggleClass('is-active', isMatch).prop('hidden', !isMatch);
      });
    });
  }

  function initCustomerAccountConfig() {
    var $dashboards = $('[data-everhem-account-dashboard]');
    if (!$dashboards.length) return;

    var dashboardNode = $dashboards[0] || ($dashboards.get ? $dashboards.get(0) : null);
    if (!dashboardNode) return;

    var $dashboard = $(dashboardNode);
    var clientId = $dashboard.attr('data-customer-account-client-id');
    if (clientId) {
      window.EverhemTheme.customerAccountClientId = clientId;
    }
  }

  function resolveDashboardAuthState() {
    var pathname = window.location.pathname;
    if (pathname === ACCOUNT_AUTH_CALLBACK_PATH) {
      console.log('[everhem account] dashboard auth state resolved: callback', {
        pathname: pathname,
      });
      return 'callback';
    }

    if (hasValidToken()) {
      console.log('[everhem account] dashboard auth state resolved: authenticated', {
        pathname: pathname,
      });
      return 'authenticated';
    }

    var expiryStatus = getTokenExpiryStatus();
    if (expiryStatus === 'expired' || expiryStatus === 'invalid') {
      console.log('[everhem account] dashboard auth state resolved: expired', {
        pathname: pathname,
        expiryStatus: expiryStatus,
      });
      return 'expired';
    }

    console.log('[everhem account] dashboard auth state resolved: signed_out', {
      pathname: pathname,
      expiryStatus: expiryStatus,
    });
    return 'signed_out';
  }

  function loadAccountDashboard() {
    var $dashboards = $('[data-everhem-account-dashboard]');
    if (!$dashboards.length) return;

    var dashboardNode = $dashboards[0] || ($dashboards.get ? $dashboards.get(0) : null);
    if (!dashboardNode) return;

    var $dashboard = $(dashboardNode);

    var configuredClientId = $dashboard.attr('data-customer-account-client-id');
    if (configuredClientId && !window.EverhemTheme.customerAccountClientId) {
      window.EverhemTheme.customerAccountClientId = configuredClientId;
    }

    var configuredBaseUrl = $dashboard.attr('data-backend-base-url');
    if (configuredBaseUrl && !window.EverhemTheme.accountBackendBaseUrl) {
      window.EverhemTheme.accountBackendBaseUrl = trimTrailingSlash(configuredBaseUrl);
    }

    var baseUrl = getAccountBackendBaseUrl();
    var $signedOut = $dashboard.find('[data-account-signed-out]');
    var $authLoading = $dashboard.find('[data-account-auth-loading]');
    var $signedIn = $dashboard.find('[data-account-signed-in]');
    var $errors = $dashboard.find('[data-account-errors]');
    var $orders = $dashboard.find('[data-account-orders]');
    var $quotes = $dashboard.find('[data-account-quotes]');
    var $orderDetail = $dashboard.find('[data-account-order-detail-body]');
    var $quoteDetail = $dashboard.find('[data-account-quote-detail-body]');
    var ordersState = [];
    var quotesState = [];
    var activeOrderId = null;
    var activeQuoteId = null;
    var quoteCartBusy = false;
    var $addresses = $dashboard.find('[data-account-addresses]');
    var $accountDetails = $dashboard.find('[data-account-details]');
    var accountState = null;
    var addressesBusy = false;
    var accountDetailsBusy = false;

    function setError(message) {
      if (!message) {
        $errors.text('').prop('hidden', true);
        return;
      }

      $errors.text(message).prop('hidden', false);
    }

    function setDashboardMode(mode) {
      console.log('[everhem account] set dashboard mode', {
        mode: mode,
        pathname: window.location.pathname,
      });
      $signedOut.prop('hidden', mode !== 'signed_out');
      $authLoading.prop('hidden', mode !== 'loading');
      $signedIn.prop('hidden', mode !== 'signed_in');
    }

    function renderOrdersList() {
      if (!ordersState.length) {
        renderEmptyState($orders, 'No orders yet.');
        return;
      }

      var html = ordersState.slice(0, 10).map(function (order) {
        var isActive = activeOrderId && order.orderId === activeOrderId;
        return [
          '<div class="everhem-account-dashboard__list-item everhem-account-dashboard__list-item--order-card', isActive ? ' is-active' : '', '">',
          '<button class="everhem-account-dashboard__list-button everhem-account-dashboard__list-button--card" type="button" data-order-id="', escapeHtml(order.orderId || ''), '">',
          '<span class="everhem-account-dashboard__list-item-header">',
          '<span>',
          '<span class="everhem-account-dashboard__list-item-title">Order ', escapeHtml(order.orderNumber || ''), '</span>',
          '<span class="everhem-account-dashboard__list-item-meta">', escapeHtml(formatDate(order.purchaseDate)), '</span>',
          '</span>',
          '</span>',
          '<span class="everhem-account-dashboard__list-item-summary">',
          '<span class="everhem-account-dashboard__list-item-total-label">Order total</span>',
          '<span class="everhem-account-dashboard__list-item-total">', escapeHtml(order.totalCostText || formatCurrency(order.totalCost || 0)), '</span>',
          '</span>',
          '</button>',
          '<div class="everhem-account-dashboard__order-inline-detail" data-order-inline-detail="', escapeHtml(order.orderId || ''), '"', isActive ? '' : ' hidden', '>',
          isActive ? '<p class="everhem-account-dashboard__empty">Loading order detail…</p>' : '',
          '</div>',
          '</div>'
        ].join('');
      }).join('');

      $orders.html(html);
      $orders.find('[data-order-id]').on('click', function () {
        var orderId = $(this).attr('data-order-id');
        if (!orderId) return;
        loadOrderDetail(orderId);
      });
    }

    function renderQuotesList() {
      if (!quotesState.length) {
        renderEmptyState($quotes, 'No quotes yet.');
        return;
      }

      var html = quotesState.slice(0, 10).map(function (quote) {
        var isActive = activeQuoteId && quote.id === activeQuoteId;
        return [
          '<div class="everhem-account-dashboard__list-item everhem-account-dashboard__list-item--order-card', isActive ? ' is-active' : '', '">',
          '<button class="everhem-account-dashboard__list-button everhem-account-dashboard__list-button--card" type="button" data-quote-id="', escapeHtml(quote.id || ''), '">',
          '<span class="everhem-account-dashboard__list-item-header">',
          '<span>',
          '<span class="everhem-account-dashboard__list-item-title">', escapeHtml(quote.name || ('Quote #' + quote.id)), '</span>',
          '<span class="everhem-account-dashboard__list-item-meta">', escapeHtml(formatDate(quote.createdAt)), '</span>',
          '</span>',
          // '<span class="everhem-account-dashboard__status ', quoteStatusClass(quote.status), '">', escapeHtml(quote.status || 'draft'), '</span>',
          '</span>',
          '<span class="everhem-account-dashboard__list-item-summary">',
          '<span class="everhem-account-dashboard__list-item-total-label">Quote total</span>',
          '<span class="everhem-account-dashboard__list-item-total">', escapeHtml(formatCurrency(quote.cost || 0)), '</span>',
          '</span>',
          '</button>',
          '<div class="everhem-account-dashboard__order-inline-detail" data-quote-inline-detail="', escapeHtml(quote.id || ''), '"', isActive ? '' : ' hidden', '>',
          isActive ? '<p class="everhem-account-dashboard__empty">Loading quote detail…</p>' : '',
          '</div>',
          '</div>'
        ].join('');
      }).join('');

      $quotes.html(html);
      $quotes.find('[data-quote-id]').on('click', function () {
        var quoteId = $(this).attr('data-quote-id');
        if (!quoteId) return;
        loadQuoteDetail(quoteId);
      });
    }

    function loadOrderDetail(orderId) {
      if (activeOrderId === orderId) {
        activeOrderId = null;
        renderOrdersList();
        return;
      }

      activeOrderId = orderId;
      renderOrdersList();

      var $inlineDetail = $orders.find('[data-order-inline-detail="' + orderId + '"]');
      $inlineDetail.prop('hidden', false).html('<p class="everhem-account-dashboard__empty">Loading order detail…</p>');

      fetchJsonAuthed(baseUrl, '/api/order-details?id=' + encodeURIComponent(orderId))
        .then(function (response) {
          var raw = unwrapJqueryResponse(response);
          console.log('[everhem order detail] raw response', raw);
          var detail = raw.order || raw;
          var html = [
            '<div class="everhem-account-dashboard__detail-card everhem-account-dashboard__detail-card--hero">',
            '<div class="everhem-account-dashboard__detail-rows">', renderOrderRows(detail), '</div>',
            '</div>',
            '<div class="everhem-account-dashboard__detail-card">',
            '<div class="everhem-account-dashboard__detail-card-header">',
            '<div>',
            '<p class="everhem-account-dashboard__detail-kicker">Order items</p>',
            '<h4 class="everhem-account-dashboard__detail-title">Items in this order</h4>',
            '</div>',
            '<a class="everhem-account-dashboard__detail-action" href="/pages/contact" target="_blank" rel="noopener noreferrer">Need help?</a>',
            '</div>',
            renderOrderItems(detail),
            '</div>'
          ].join('');

          $inlineDetail.html(html);
        })
        .catch(function (xhr) {
          var failure = classifyAccountError(xhr, 'Could not load that order detail.');
          $inlineDetail.html('<p class="everhem-account-dashboard__empty">Could not load that order detail.</p>');
          setError(failure.message);
        });
    }

    function bindAddQuoteToCart(detail, $container) {
      $container.find('[data-add-quote-to-cart]').on('click', function () {
        if (quoteCartBusy) return;

        quoteCartBusy = true;
        setError('');

        var button = this;
        var originalText = button.textContent || 'Add quote to cart';
        var addedBatchCount = 0;
        button.disabled = true;
        button.textContent = 'Preparing quote…';

        postJsonAuthed(baseUrl, '/api/add-quote-to-cart', { id: detail.id })
          .then(function (response) {
            var payload = unwrapJqueryResponse(response);
            var batches = payload && payload.batches ? payload.batches : [];
            var redirectUrl = payload && payload.redirectUrl ? payload.redirectUrl : '/cart';

            if (!batches.length) {
              throw new Error('This quote has no cart-ready products yet.');
            }

            var sequence = Promise.resolve();
            batches.forEach(function (batch, index) {
              sequence = sequence.then(function () {
                button.textContent = 'Adding batch ' + (index + 1) + ' of ' + batches.length + '…';
                return addNativeCartBatch(batch).then(function (result) {
                  addedBatchCount += 1;
                  trackAddToCartBatch('product', result && result.items ? result.items : [], {
                    source: 'account_quote',
                    quote_id: detail.id,
                  });
                  return result;
                });
              });
            });

            return sequence.then(function () {
              var handler = window.EverhemTheme && window.EverhemTheme.handleExternalCartAdded;

              if (typeof handler === 'function') {
                return handler().then(function () {
                  setError('');
                  button.disabled = false;
                  button.textContent = originalText;
                  quoteCartBusy = false;
                });
              }

              window.location.href = redirectUrl;
            });
          })
          .catch(function (error) {
            var failure = error && typeof error.status === 'number'
              ? classifyAccountError(error, 'Could not add that quote to your cart.')
              : null;
            var message = failure && failure.message
              ? failure.message
              : error && error.message
                ? error.message
                : 'Could not add that quote to your cart.';

            if (addedBatchCount > 0) {
              message += ' Some items may already be in your cart.';
            }

            setError(message);
            button.disabled = false;
            button.textContent = originalText;
            quoteCartBusy = false;
          });
      });
    }

    function loadQuoteDetail(quoteId) {
      if (activeQuoteId === quoteId) {
        activeQuoteId = null;
        renderQuotesList();
        return;
      }

      activeQuoteId = quoteId;
      renderQuotesList();

      var $inlineDetail = $quotes.find('[data-quote-inline-detail="' + quoteId + '"]');
      $inlineDetail.prop('hidden', false).html('<p class="everhem-account-dashboard__empty">Loading quote detail…</p>');

      fetchJsonAuthed(baseUrl, '/api/quote?id=' + encodeURIComponent(quoteId))
        .then(function (response) {
          var payload = unwrapJqueryResponse(response);
          var detail = payload && payload.quote ? payload.quote : null;

          if (!detail) {
            $inlineDetail.html('<p class="everhem-account-dashboard__empty">Quote not found.</p>');
            return;
          }

          var canAddToCart = detail.status !== 'archived' && !!(detail.products && detail.products.length);
          var html = [
            '<div class="everhem-account-dashboard__detail-card everhem-account-dashboard__detail-card--hero">',
            '<div class="everhem-account-dashboard__detail-header">',
            '<div>',
            '<p class="everhem-account-dashboard__detail-kicker">Quote</p>',
            '<h4 class="everhem-account-dashboard__detail-title">', escapeHtml(detail.name || ('Quote #' + detail.id)), '</h4>',
            '<span class="everhem-account-dashboard__detail-meta">', escapeHtml(formatDate(detail.createdAt)), '</span>',
            '</div>',
            // '<span class="everhem-account-dashboard__status ', quoteStatusClass(detail.status), '">', escapeHtml(detail.status || 'draft'), '</span>',
            '</div>',
            '<div class="everhem-account-dashboard__detail-rows">', renderQuoteRows(detail), '</div>',
            canAddToCart ? '<div class="everhem-account-dashboard__detail-actions"><button class="everhem-account-dashboard__button" type="button" data-add-quote-to-cart>Add quote to cart</button></div>' : '',
            '</div>',
            '<div class="everhem-account-dashboard__detail-card">',
            '<div class="everhem-account-dashboard__detail-card-header">',
            '<div>',
            '<p class="everhem-account-dashboard__detail-kicker">Quote products</p>',
            '<h4 class="everhem-account-dashboard__detail-title">Products in this quote</h4>',
            '</div>',
            '<a class="everhem-account-dashboard__detail-action" href="/pages/contact" target="_blank" rel="noopener noreferrer">Need help?</a>',
            '</div>',
            renderQuoteItems(detail),
            '</div>'
          ].join('');

          $inlineDetail.html(html);
          bindAddQuoteToCart(detail, $inlineDetail);
        })
        .catch(function (xhr) {
          var failure = classifyAccountError(xhr, 'Could not load that quote detail.');
          $inlineDetail.html('<p class="everhem-account-dashboard__empty">Could not load that quote detail.</p>');
          setError(failure.message);
        });
    }

    function renderAccountDetailsPanel(account) {
      if (!account) {
        $accountDetails.html('<p class="everhem-account-dashboard__empty">Could not load account details.</p>');
        return;
      }

      var name = [account.firstName, account.lastName].filter(Boolean).join(' ') || '—';
      var rows = [
        ['Name', escapeHtml(name)],
        ['Email', escapeHtml(account.email || '—')],
        ['Phone', escapeHtml(account.phone || '—')],
      ].map(function (row) {
        return '<div class="everhem-account-dashboard__detail-row"><dt>' + row[0] + '</dt><dd>' + row[1] + '</dd></div>';
      }).join('');

      var html = [
        '<div data-account-details-view>',
        rows,
        '<div class="everhem-account-dashboard__detail-actions">',
        '<button class="everhem-account-dashboard__button" type="button" data-edit-account-details>Edit details</button>',
        '</div>',
        '</div>',
        '<div data-account-details-form hidden>',
        '<form data-update-account-form>',
        '<div class="everhem-account-dashboard__form-fields">',
        renderAccountField('First name', 'firstName', account.firstName || ''),
        renderAccountField('Last name', 'lastName', account.lastName || ''),
        renderAccountField('Email', 'email', account.email || '', 'email'),
        renderAccountField('Phone', 'phone', account.phone || '', 'tel'),
        '</div>',
        '<div class="everhem-account-dashboard__detail-actions">',
        '<button class="everhem-account-dashboard__button" type="submit" data-update-account-submit>Save changes</button>',
        '<button class="everhem-account-dashboard__link-button" type="button" data-cancel-account-edit>Cancel</button>',
        '</div>',
        '<p class="everhem-account-dashboard__form-message" data-account-details-message hidden></p>',
        '</form>',
        '</div>',
      ].join('');

      $accountDetails.html(html);
      bindAccountDetailsActions($accountDetails);
    }

    function renderAccountField(label, name, value, type) {
      type = type || 'text';
      return [
        '<label class="everhem-account-dashboard__form-field">',
        '<span class="everhem-account-dashboard__detail-kicker">' + escapeHtml(label) + '</span>',
        '<input class="everhem-account-dashboard__input" type="' + escapeHtml(type) + '" name="' + escapeHtml(name) + '" value="' + escapeHtml(value) + '">',
        '</label>',
      ].join('');
    }

    function bindAccountDetailsActions($container) {
      var $view = $container.find('[data-account-details-view]');
      var $formWrap = $container.find('[data-account-details-form]');
      var $message = $container.find('[data-account-details-message]');

      $container.find('[data-edit-account-details]').on('click', function () {
        $view.prop('hidden', true);
        $formWrap.prop('hidden', false);
        $message.prop('hidden', true).text('');
      });

      $container.find('[data-cancel-account-edit]').on('click', function () {
        $view.prop('hidden', false);
        $formWrap.prop('hidden', true);
        $message.prop('hidden', true).text('');
      });

      $container.find('[data-update-account-form]').on('submit', function (e) {
        e.preventDefault();
        if (accountDetailsBusy) return;

        var $f = $(this);
        var $btn = $container.find('[data-update-account-submit]');
        var data = {
          firstName: $f.find('[name="firstName"]').val().trim(),
          lastName: $f.find('[name="lastName"]').val().trim(),
          email: $f.find('[name="email"]').val().trim(),
          phone: $f.find('[name="phone"]').val().trim(),
        };

        accountDetailsBusy = true;
        $btn.prop('disabled', true).text('Saving…');
        $message.prop('hidden', true).text('');

        postJsonAuthed(baseUrl, '/api/update-account', data)
          .then(function () {
            accountState = Object.assign({}, accountState, data);
            accountDetailsBusy = false;
            renderAccountDetailsPanel(accountState);
            $dashboard.find('[data-account-name]').text('Hello, ' + ([accountState.firstName, accountState.lastName].filter(Boolean).join(' ') || 'there'));
            $dashboard.find('[data-account-email]').text(accountState.email || '');
          })
          .catch(function (xhr) {
            var failure = classifyAccountError(xhr, 'Could not update account details.');
            $message.text(failure.message).prop('hidden', false);
            $btn.prop('disabled', false).text('Save changes');
            accountDetailsBusy = false;
          });
      });
    }

    function renderAddressList(addresses) {
      if (!addresses || !addresses.length) {
        renderEmptyState($addresses, 'No saved addresses yet.');
        return;
      }

      var html = addresses.map(function (address) {
        var id = escapeHtml(address.id || '');
        var lines = [
          [address.firstName, address.lastName].filter(Boolean).join(' '),
          address.address1,
          address.address2,
          [address.city, address.zoneCode || address.provinceCode, address.zip].filter(Boolean).join(', '),
          address.territoryCode || address.countryCode,
        ].filter(Boolean).map(escapeHtml).join('<br>');

        return [
          '<div class="everhem-account-dashboard__list-item everhem-account-dashboard__list-item--order-card">',
          '<div class="everhem-account-dashboard__list-button--card">',
          address.isDefault ? '<span class="everhem-account-dashboard__status everhem-account-dashboard__status--published" style="margin-bottom:0.5rem;display:inline-flex;">Default</span>' : '',
          '<address class="everhem-account-dashboard__list-item-meta" style="font-style:normal;margin:0;">', lines, '</address>',
          '<div class="everhem-account-dashboard__detail-actions">',
          '<button class="everhem-account-dashboard__link-button" type="button" data-edit-address="', id, '">Edit</button>',
          !address.isDefault ? '<button class="everhem-account-dashboard__link-button" type="button" data-set-default-address="' + id + '">Set as default</button>' : '',
          '<button class="everhem-account-dashboard__link-button everhem-account-dashboard__link-button--danger" type="button" data-delete-address="', id, '">Delete</button>',
          '</div>',
          '<div class="everhem-account-dashboard__order-inline-detail" data-address-edit-form="', id, '" hidden></div>',
          '</div>',
          '</div>',
        ].join('');
      }).join('');

      $addresses.html(html);
      bindAddressActions($addresses, addresses);
    }

    function bindAddressActions($container, addresses) {
      $container.find('[data-delete-address]').on('click', function () {
        if (addressesBusy) return;
        var id = $(this).attr('data-delete-address');
        if (!id || !window.confirm('Delete this address?')) return;

        addressesBusy = true;
        postJsonAuthed(baseUrl, '/api/customer-address', { action: 'delete', addressId: id })
          .then(function () {
            addressesBusy = false;
            var updated = (accountState.addresses || []).filter(function (a) { return a.id !== id; });
            accountState = Object.assign({}, accountState, { addresses: updated });
            renderAddressList(updated);
          })
          .catch(function (xhr) {
            addressesBusy = false;
            var failure = classifyAccountError(xhr, 'Could not delete that address.');
            setError(failure.message);
          });
      });

      $container.find('[data-set-default-address]').on('click', function () {
        if (addressesBusy) return;
        var id = $(this).attr('data-set-default-address');
        if (!id) return;

        addressesBusy = true;
        postJsonAuthed(baseUrl, '/api/customer-address', { action: 'setDefault', addressId: id })
          .then(function (response) {
            var payload = unwrapJqueryResponse(response);
            addressesBusy = false;
            var newDefaultId = (payload && payload.defaultAddress && payload.defaultAddress.id) || id;
            var updated = (accountState.addresses || []).map(function (a) {
              return Object.assign({}, a, { isDefault: a.id === newDefaultId });
            });
            accountState = Object.assign({}, accountState, { addresses: updated });
            renderAddressList(updated);
          })
          .catch(function (xhr) {
            addressesBusy = false;
            var failure = classifyAccountError(xhr, 'Could not set default address.');
            setError(failure.message);
          });
      });

      $container.find('[data-edit-address]').on('click', function () {
        var id = $(this).attr('data-edit-address');
        if (!id) return;
        var address = (addresses || []).filter(function (a) { return a.id === id; })[0];
        var $slot = $container.find('[data-address-edit-form="' + id + '"]');
        if (!$slot.prop('hidden')) {
          $slot.prop('hidden', true).html('');
          return;
        }
        $slot.prop('hidden', false).html(renderAddressForm(address));
        bindAddressFormSubmit($slot, 'update', id);
      });
    }

    function renderAddressForm(address) {
      address = address || {};
      return [
        '<form data-address-form-inner>',
        '<div class="everhem-account-dashboard__form-fields">',
        renderAddressField('First name', 'firstName', address.firstName || ''),
        renderAddressField('Last name', 'lastName', address.lastName || ''),
        renderAddressField('Address line 1', 'address1', address.address1 || ''),
        renderAddressField('Address line 2 (optional)', 'address2', address.address2 || ''),
        renderAddressField('City', 'city', address.city || ''),
        renderAddressField('State code', 'zoneCode', address.zoneCode || address.provinceCode || '', 'text', 'e.g. CA'),
        renderAddressField('ZIP', 'zip', address.zip || ''),
        renderAddressField('Country code', 'territoryCode', address.territoryCode || address.countryCode || 'US', 'text', 'e.g. US'),
        renderAddressField('Phone (optional)', 'phoneNumber', address.phoneNumber || address.phone || '', 'tel'),
        '</div>',
        '<div class="everhem-account-dashboard__detail-actions">',
        '<button class="everhem-account-dashboard__button" type="submit" data-address-submit>Save address</button>',
        '<button class="everhem-account-dashboard__link-button" type="button" data-address-cancel>Cancel</button>',
        '</div>',
        '<p class="everhem-account-dashboard__form-message" data-address-message hidden></p>',
        '</form>',
      ].join('');
    }

    function renderAddressField(label, name, value, type, placeholder) {
      type = type || 'text';
      return [
        '<label class="everhem-account-dashboard__form-field">',
        '<span class="everhem-account-dashboard__detail-kicker">' + escapeHtml(label) + '</span>',
        '<input class="everhem-account-dashboard__input" type="' + escapeHtml(type) + '" name="' + escapeHtml(name) + '" value="' + escapeHtml(value) + '"' + (placeholder ? ' placeholder="' + escapeHtml(placeholder) + '"' : '') + '>',
        '</label>',
      ].join('');
    }

    function bindAddressFormSubmit($slot, action, addressId) {
      $slot.find('[data-address-cancel]').on('click', function () {
        $slot.prop('hidden', true).html('');
      });

      $slot.find('[data-address-form-inner]').on('submit', function (e) {
        e.preventDefault();
        if (addressesBusy) return;

        var $f = $(this);
        var $btn = $slot.find('[data-address-submit]');
        var $msg = $slot.find('[data-address-message]');
        var address = {
          firstName: $f.find('[name="firstName"]').val().trim(),
          lastName: $f.find('[name="lastName"]').val().trim(),
          address1: $f.find('[name="address1"]').val().trim(),
          address2: $f.find('[name="address2"]').val().trim(),
          city: $f.find('[name="city"]').val().trim(),
          zoneCode: $f.find('[name="zoneCode"]').val().trim(),
          zip: $f.find('[name="zip"]').val().trim(),
          territoryCode: $f.find('[name="territoryCode"]').val().trim() || 'US',
          phoneNumber: $f.find('[name="phoneNumber"]').val().trim(),
        };

        var body = action === 'create'
          ? { action: 'create', defaultAddress: false, address: address }
          : { action: 'update', addressId: addressId, address: address };

        addressesBusy = true;
        $btn.prop('disabled', true).text('Saving…');
        $msg.prop('hidden', true).text('');

        postJsonAuthed(baseUrl, '/api/customer-address', body)
          .then(function (response) {
            var payload = unwrapJqueryResponse(response);
            addressesBusy = false;
            var updated;
            if (action === 'create') {
              var newAddress = (payload && payload.address) ? payload.address : Object.assign({ id: 'temp-' + Date.now() }, address);
              updated = (accountState.addresses || []).concat([newAddress]);
            } else {
              updated = (accountState.addresses || []).map(function (a) {
                return a.id === addressId ? Object.assign({}, a, address) : a;
              });
            }
            accountState = Object.assign({}, accountState, { addresses: updated });
            renderAddressList(updated);
          })
          .catch(function (xhr) {
            addressesBusy = false;
            var failure = classifyAccountError(xhr, 'Could not save that address.');
            $msg.text(failure.message).prop('hidden', false);
            $btn.prop('disabled', false).text('Save address');
          });
      });
    }

    bindAccountDashboardTabs($dashboard);

    var $addAddressBtn = $dashboard.find('[data-account-add-address]');
    var $addAddressSlot = $('<div class="everhem-account-dashboard__order-inline-detail" data-address-new-form hidden></div>');
    $addAddressBtn.closest('.everhem-account-dashboard__panel-header').after($addAddressSlot);
    $addAddressBtn.on('click', function () {
      if (!$addAddressSlot.prop('hidden')) {
        $addAddressSlot.prop('hidden', true).html('');
        return;
      }
      $addAddressSlot.prop('hidden', false).html(renderAddressForm(null));
      bindAddressFormSubmit($addAddressSlot, 'create', null);
    });

    hideCallbackState();

    console.log('[everhem account] dashboard boot', {
      pathname: window.location.pathname,
      baseUrl: baseUrl,
      hasStoredToken: !!getStoredTokens(),
      hasStoredAuthState: !!getStoredAuthState(),
      globalClientIdPresent: !!window.EverhemTheme.customerAccountClientId,
      globalBackendBaseUrl: window.EverhemTheme.accountBackendBaseUrl || null,
    });

    var authState = resolveDashboardAuthState();
    if (authState === 'callback') {
      setDashboardMode('loading');
      return;
    }

    if (authState === 'signed_out') {
      setDashboardMode('signed_out');
      setError('');
      renderEmptyState($orders, 'Sign in to load orders.');
      renderEmptyState($quotes, 'Sign in to load quotes.');
      renderEmptyState($orderDetail, 'Sign in to load order detail.');
      renderEmptyState($quoteDetail, 'Sign in to load quote detail.');
      return;
    }

    if (authState === 'expired') {
      setDashboardMode('signed_out');
      setError('Your Everhem account session expired. Sign in again and we will pick back up.');
      renderEmptyState($orders, 'Sign in again to load orders.');
      renderEmptyState($quotes, 'Sign in again to load quotes.');
      renderEmptyState($orderDetail, 'Sign in again to load order detail.');
      renderEmptyState($quoteDetail, 'Sign in again to load quote detail.');
      return;
    }

    setDashboardMode('loading');
    console.log('[everhem account] checking signed-in state via backend account endpoints');

    ensureCustomerAccountToken({ requireAuth: true })
      .then(function (token) {
        return Promise.all([
          fetchJson(baseUrl, '/api/account', token),
          fetchJson(baseUrl, '/api/orders?first=10', token),
          fetchJson(baseUrl, '/api/quotes', token),
          postJson(baseUrl, '/api/customer-address', { action: 'list' }, token)
        ]);
      })
      .then(function (responses) {
        var account = unwrapJqueryResponse(responses[0]);
        var ordersPayload = unwrapJqueryResponse(responses[1]);
        var quotesPayload = unwrapJqueryResponse(responses[2]);
        var addressPayload = unwrapJqueryResponse(responses[3]);
        var defaultAddressId = (addressPayload && addressPayload.defaultAddressId) || null;
        var addresses = ((addressPayload && addressPayload.addresses) || []).map(function (a) {
          return Object.assign({}, a, { isDefault: a.id === defaultAddressId });
        });

        console.log('[everhem account] backend responses received', {
          accountResponse: account,
          ordersCount: ordersPayload && ordersPayload.orders ? ordersPayload.orders.length : null,
          quotesCount: quotesPayload && quotesPayload.quotes ? quotesPayload.quotes.length : null,
        });
        var displayName = account.fullName || [account.firstName, account.lastName].filter(Boolean).join(' ') || 'Everhem customer';
        var sinceText = account.since ? ('Member since ' + formatDate(account.since * 1000)) : '';

        ordersState = ordersPayload.orders || [];
        quotesState = quotesPayload.quotes || [];
        accountState = Object.assign({}, account, { addresses: addresses });

        $dashboard.find('[data-account-name]').text('Hello, ' + displayName);
        $dashboard.find('[data-account-email]').text(account.email || '');

        if (account.isTradeProfessional) {
          $dashboard.find('[data-account-trade]').prop('hidden', false);
        }

        if (sinceText) {
          $dashboard.find('[data-account-member-since]').text(sinceText).prop('hidden', false);
        }

        renderOrdersList();
        renderQuotesList();
        renderAccountDetailsPanel(account);
        renderAddressList(addresses);

        setDashboardMode('signed_in');
        setError('');
      })
      .catch(function (xhr) {
        var status = xhr && xhr.status;
        var failure = classifyAccountError(xhr, 'We hit a snag loading account data.');

        console.log('[everhem account] backend request failed', {
          status: status,
          responseJSON: xhr && xhr.responseJSON,
          responseText: xhr && xhr.responseText,
          classifiedFailure: failure,
        });

        if (failure.type === 'unauthenticated') {
          setDashboardMode('signed_out');
          renderEmptyState($orders, 'Sign in to load orders.');
          renderEmptyState($quotes, 'Sign in to load quotes.');
          renderEmptyState($orderDetail, 'Sign in to load order detail.');
          renderEmptyState($quoteDetail, 'Sign in to load quote detail.');
          setError(failure.message);
          return;
        }

        if (!hasValidToken()) {
          setDashboardMode('signed_out');
          setError('No valid Shopify customer token found yet. We likely need to complete the customer account OAuth callback flow.');
          return;
        }

        setDashboardMode('signed_in');
        setError(failure.message);
        renderEmptyState($orders, 'Could not load orders.');
        renderEmptyState($quotes, 'Could not load quotes.');
        renderEmptyState($orderDetail, 'Could not load order detail.');
        renderEmptyState($quoteDetail, 'Could not load quote detail.');
      });
  }

  /**
   * Generic data-toggle pattern: add data-toggle-class + data-target
   * to any element to toggle a class on a target on click.
   */
  function bindToggleClass() {
    $('[data-toggle-class]').each(function () {
      var $trigger = $(this);
      var target = $trigger.attr('data-target');
      var className = $trigger.attr('data-toggle-class');

      if (!target || !className) return;

      $trigger.on('click', function () {
        $(target).toggleClass(className);
      });
    });
  }

  function bindHeaderScrollState() {
    var header = document.querySelector('.everhem-header');
    if (!header) return;

    var THRESHOLD = 80;
    var ticking = false;

    function syncHeaderMetrics() {
      document.documentElement.style.setProperty('--everhem-header-height', header.offsetHeight + 'px');
    }

    function update() {
      header.classList.toggle('everhem-header--scrolled', window.scrollY > THRESHOLD);
      syncHeaderMetrics();
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    window.addEventListener('resize', syncHeaderMetrics);
    syncHeaderMetrics();
    update();
  }

  function bindTabs() {
    var roots = document.querySelectorAll('[data-tabs-root]');

    function getParamName(root) {
      return root.getAttribute('data-tabs-param') || 'guide';
    }

    function getRequestedSlug(root) {
      try {
        return new URLSearchParams(window.location.search).get(getParamName(root));
      } catch (e) {
        return null;
      }
    }

    function findButtonBySlug(buttons, slug) {
      if (!slug) return null;
      for (var i = 0; i < buttons.length; i += 1) {
        if (buttons[i].getAttribute('data-tab-slug') === slug) return buttons[i];
      }
      return null;
    }

    function syncUrl(root, slug) {
      if (!slug || !window.history || !window.history.pushState) return;

      try {
        var paramName = getParamName(root);
        var url = new URL(window.location.href);
        if (url.searchParams.get(paramName) === slug) return;

        url.searchParams.set(paramName, slug);
        window.history.pushState({ everhemTabs: true }, '', url.toString());
      } catch (e) {
        // URL state is progressive enhancement; tab switching should still work.
      }
    }

    function activateTab(root, btn, updateUrl) {
      if (!btn) return;

      var buttons = root.querySelectorAll('[data-tab-target]');
      var panels = root.querySelectorAll('.everhem-tabs__panel');
      var targetId = btn.getAttribute('data-tab-target');

      buttons.forEach(function (button) {
        button.classList.remove('is-active');
        button.setAttribute('aria-selected', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-selected', 'true');

      panels.forEach(function (panel) {
        panel.classList.remove('is-active');
        if (panel.id === targetId) panel.classList.add('is-active');
      });

      if (updateUrl) syncUrl(root, btn.getAttribute('data-tab-slug'));
    }

    roots.forEach(function (root) {
      var buttons = root.querySelectorAll('[data-tab-target]');
      var requestedButton = findButtonBySlug(buttons, getRequestedSlug(root));
      if (requestedButton) activateTab(root, requestedButton, false);

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () { activateTab(root, btn, true); });
      });
    });

    window.addEventListener('popstate', function () {
      roots.forEach(function (root) {
        var buttons = root.querySelectorAll('[data-tab-target]');
        var requestedButton = findButtonBySlug(buttons, getRequestedSlug(root));
        activateTab(root, requestedButton || buttons[0], false);
      });
    });
  }

  function bindCarouselDrag() {
    document.querySelectorAll('[data-carousel-drag]').forEach(function (track) {
      var isDown = false;
      var startX = 0;
      var startScroll = 0;
      var moved = 0;

      track.addEventListener('mousedown', function (e) {
        isDown = true;
        moved = 0;
        startX = e.pageX - track.offsetLeft;
        startScroll = track.scrollLeft;
      });

      track.addEventListener('mouseleave', function () { isDown = false; track.classList.remove('is-dragging'); });
      track.addEventListener('mouseup', function () {
        isDown = false;
        setTimeout(function () { track.classList.remove('is-dragging'); }, 0);
      });

      track.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - track.offsetLeft;
        var delta = x - startX;
        moved = Math.abs(delta);
        if (moved > 6) track.classList.add('is-dragging');
        track.scrollLeft = startScroll - delta;
      });

      track.addEventListener('click', function (e) {
        if (moved > 6) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    });
  }

  function bindCarouselArrows() {
    document.querySelectorAll('[data-carousel-root]').forEach(function (root) {
      var track = root.querySelector('[data-carousel-track]');
      if (!track) return;
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      var card = root.closest('.everhem-picks__card');
      var dots = card ? card.querySelectorAll('[data-carousel-dot]') : [];
      var cta = card ? card.querySelector('[data-designer-picks-cta]') : null;
      var shopLink = cta ? cta.querySelector('[data-designer-picks-shop]') : null;
      var addButton = cta ? cta.querySelector('[data-designer-picks-add-swatch]') : null;

      function scrollAmount() {
        var first = track.firstElementChild;
        if (!first) return 320;
        var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 16, 10);
        return first.offsetWidth + (isNaN(gap) ? 16 : gap);
      }

      function activeIndex() {
        var amount = scrollAmount();
        return amount > 0 ? Math.round(track.scrollLeft / amount) : 0;
      }

      function scrollToIndex(index) {
        track.scrollTo({ left: scrollAmount() * index, behavior: 'smooth' });
      }

      function updateDots() {
        if (!dots.length) return;
        var index = activeIndex();
        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      }

      function syncActiveSlideCta() {
        if (!cta) return;
        var index = activeIndex() + 1;
        var defaultLink = cta.getAttribute('data-default-link') || '#';
        var variantId = cta.getAttribute('data-slide-' + index + '-variant-id') || '';
        var available = cta.getAttribute('data-slide-' + index + '-available') === 'true';
        if (shopLink) shopLink.setAttribute('href', defaultLink);
        if (addButton) {
          addButton.setAttribute('data-variant-id', variantId);
          addButton.disabled = !variantId || !available;
        }
      }

      function updateButtons() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.toggleAttribute('disabled', track.scrollLeft <= 1);
        if (next) next.toggleAttribute('disabled', track.scrollLeft >= max - 1);
        updateDots();
        syncActiveSlideCta();
      }

      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(dot.getAttribute('data-slide-index') || '0', 10);
          scrollToIndex(isNaN(index) ? 0 : index);
        });
      });

      if (addButton) {
        addButton.addEventListener('click', function () {
          var variantId = addButton.getAttribute('data-variant-id');
          if (!variantId) return;
          addButton.disabled = true;
          addToCart({ id: variantId, quantity: 1 })
            .then(function (item) {
              trackAddToCart('swatch', item, {
                variantId: variantId,
                quantity: 1,
                productType: 'Swatch',
              });
              return refreshCartDrawer({ open: true });
            })
            .then(function (cart) {
              refreshCartDrawer({ open: true, cart: cart });
              setCartCount(cart.item_count);
              setCartStatus('Added to cart.', false);
            })
            .catch(function () {
              setCartStatus('Could not add that swatch right now.', true);
            })
            .finally(function () {
              syncActiveSlideCta();
            });
        });
      }

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  }

  function bindMobileNav() {
    var panel = document.querySelector('[data-mobile-nav-panel]');
    var toggle = document.querySelector('[data-mobile-nav-toggle]');
    var closers = document.querySelectorAll('[data-mobile-nav-close]');
    var overlay = document.querySelector('[data-mobile-nav-overlay]');
    var links = panel ? panel.querySelectorAll('a') : [];
    var groups = panel ? panel.querySelectorAll('.everhem-header__mobile-group') : [];
    var closeTimer = null;
    if (!panel || !toggle) return;

    function closeOtherGroups(current) {
      groups.forEach(function (group) {
        if (group !== current) {
          group.removeAttribute('open');
        }
      });
    }

    function openNav() {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }

      panel.hidden = false;
      closers.forEach(function (closer) { closer.hidden = false; });
      requestAnimationFrame(function () {
        panel.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
      });
      document.body.classList.add('everhem-mobile-nav-open');
      toggle.setAttribute('aria-expanded', 'true');
    }

    function closeNav() {
      panel.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.classList.remove('everhem-mobile-nav-open');
      toggle.setAttribute('aria-expanded', 'false');
      closeTimer = window.setTimeout(function () {
        if (!panel.classList.contains('is-open')) {
          panel.hidden = true;
          closers.forEach(function (closer) { closer.hidden = true; });
        }
        closeTimer = null;
      }, 280);
    }

    toggle.addEventListener('click', function () {
      if (panel.classList.contains('is-open')) closeNav();
      else openNav();
    });

    closers.forEach(function (closer) {
      closer.addEventListener('click', closeNav);
    });

    groups.forEach(function (group) {
      group.addEventListener('toggle', function () {
        if (group.open) {
          closeOtherGroups(group);
        }
      });
    });

    links.forEach(function (link) {
      link.addEventListener('click', function () {
        closeNav();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && panel.classList.contains('is-open')) closeNav();
    });
  }

  function bindAnnouncementDismiss() {
    var bar = document.querySelector('[data-announcement-bar]');
    var triggers = document.querySelectorAll('[data-announcement-dismiss]');
    var root = document.documentElement;

    function setAnnouncementHeight(height) {
      root.style.setProperty('--everhem-announcement-height', Math.max(0, height || 0) + 'px');
    }

    if (!bar) {
      setAnnouncementHeight(0);
      return;
    }

    setAnnouncementHeight(bar.offsetHeight || 0);
    window.addEventListener('resize', function () {
      setAnnouncementHeight(bar.hidden ? 0 : bar.offsetHeight || 0);
    });

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        bar.hidden = true;
        setAnnouncementHeight(0);
      });
    });
  }

  function bindPdpConfigToggle() {
    document.querySelectorAll('[data-config-toggle]').forEach(function (toggle) {
      var btns = toggle.querySelectorAll('[data-config-mode]');
      var form = toggle.closest('form, .everhem-pdp__form') || toggle.parentElement;
      if (!form) return;

      function setMode(mode) {
        btns.forEach(function (b) {
          var isActive = b.getAttribute('data-config-mode') === mode;
          b.classList.toggle('is-active', isActive);
          b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        form.querySelectorAll('[data-config-panel]').forEach(function (panel) {
          var target = panel.getAttribute('data-config-panel');
          if (target === 'both') return;
          panel.hidden = target !== mode;
        });
      }

      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          setMode(b.getAttribute('data-config-mode'));
        });
      });

      var initial = toggle.querySelector('[data-config-mode].is-active');
      if (initial) setMode(initial.getAttribute('data-config-mode'));
    });
  }

  function bindPdpCounters() {
    var names = ['window', 'qty'];
    names.forEach(function (n) {
      document.querySelectorAll('[data-' + n + '-input]').forEach(function (input) {
        var scope = input.closest('.everhem-pdp__counter') || input.parentElement;
        if (!scope) return;
        var decr = scope.querySelector('[data-' + n + '-decr]');
        var incr = scope.querySelector('[data-' + n + '-incr]');
        var min = parseInt(input.getAttribute('min') || '1', 10);
        var max = parseInt(input.getAttribute('max') || '99', 10);

        function step(delta) {
          var v = parseInt(input.value || '1', 10);
          if (isNaN(v)) v = min;
          v = Math.max(min, Math.min(max, v + delta));
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (decr) decr.addEventListener('click', function () { step(-1); });
        if (incr) incr.addEventListener('click', function () { step(1); });
      });
    });
  }

  function bindPdpSwatchPicker() {
    document.querySelectorAll('[data-swatch-picker]').forEach(function (row) {
      var swatches = row.querySelectorAll('[data-swatch]');
      var container = row.parentElement;
      var nameEl = container ? container.querySelector('[data-swatch-name]') : null;
      var input = container ? container.querySelector('[data-fabric-input]') : null;

      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          swatches.forEach(function (s) {
            s.classList.remove('is-active');
            s.setAttribute('aria-pressed', 'false');
          });
          sw.classList.add('is-active');
          sw.setAttribute('aria-pressed', 'true');
          var name = sw.getAttribute('data-fabric-name') || '';
          if (nameEl) nameEl.textContent = name;
          if (input) input.value = name;
        });
      });
    });
  }

  function bindSwatchCollectionCards() {
    function handleSwatchCardTrigger(target) {
      var card = target.closest('.everhem-swcoll__card');
      if (!card) return;
      if (card.getAttribute('aria-disabled') === 'true') return;

      var button = card.querySelector('.everhem-swcoll__card-add');
      if (!button || button.disabled) return;

      var variantId = card.getAttribute('data-variant-id') || button.getAttribute('data-variant-id');
      if (!variantId) return;

      var originalText = button.textContent;
      button.disabled = true;
      card.classList.add('is-adding');
      button.textContent = 'Adding…';
      setCartStatus('Adding swatch…', false);

      addToCart({
        id: parseInt(variantId, 10),
        quantity: 1
      }).then(function (item) {
        trackAddToCart('swatch', item, {
          variantId: variantId,
          title: card.getAttribute('data-fabric') || '',
          productType: 'Swatch',
          sku: card.getAttribute('data-variant-sku') || '',
          price: centsToAnalyticsValue(card.getAttribute('data-price') || 0),
          fabric: card.getAttribute('data-fabric') || '',
          fabricSku: card.getAttribute('data-variant-sku') || '',
          quantity: 1,
        });
        return refreshCartDrawer({ open: true });
      }).then(function (cart) {
        setCartCount(cart && typeof cart.item_count !== 'undefined' ? cart.item_count : 0);
        setCartStatus('Added to cart.', false);
      }).catch(function (error) {
        setCartStatus(error && error.message ? error.message : 'Could not add that swatch right now.', true);
        openCartDrawer();
      }).finally(function () {
        button.disabled = false;
        card.classList.remove('is-adding');
        button.textContent = originalText;
      });
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.everhem-swcoll__card, .everhem-swcoll__card-add');
      if (!trigger) return;
      event.preventDefault();
      handleSwatchCardTrigger(trigger);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var card = event.target.closest('.everhem-swcoll__card');
      if (!card) return;
      event.preventDefault();
      handleSwatchCardTrigger(card);
    });
  }

  function bindCollabCarousel() {
    document.querySelectorAll('[data-collab-carousel]').forEach(function (root) {
      var slides = Array.from(root.querySelectorAll('[data-collab-slide]'));
      var dots = Array.from(root.querySelectorAll('[data-collab-dot]'));
      var prev = root.querySelector('[data-collab-prev]');
      var next = root.querySelector('[data-collab-next]');
      if (slides.length <= 1) return;

      var index = 0;

      function go(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, si) { s.classList.toggle('is-active', si === index); });
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
      }

      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      dots.forEach(function (d, di) {
        d.addEventListener('click', function () { go(di); });
      });
    });
  }

  function getCartDrawerRoot() {
    return document.querySelector('[data-cart-drawer-root]');
  }

  function setCartCount(count) {
    var itemCount = Number(count);

    if (!Number.isFinite(itemCount) || itemCount < 0) {
      itemCount = 0;
    }

    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = String(itemCount);
      node.classList.toggle('is-hidden', itemCount <= 0);
    });
  }

  function setCartStatus(message, isError) {
    var node = document.querySelector('[data-cart-status]');
    if (!node) return;

    if (!message) {
      node.hidden = true;
      node.textContent = '';
      node.style.color = '';
      return;
    }

    node.hidden = false;
    node.textContent = message;
    node.style.color = isError ? '#8b2f2f' : '';
  }

  function isTradeMember() {
    return !!(window.EverhemTheme && window.EverhemTheme.settings && window.EverhemTheme.settings.isTradeMember);
  }

  function getTradeDiscountRate() {
    var rate = window.EverhemTheme && window.EverhemTheme.settings
      ? Number(window.EverhemTheme.settings.tradeDiscountRate)
      : 0;

    return Number.isFinite(rate) && rate > 0 ? rate : 0;
  }

  function normalizeCents(value) {
    var cents = Number(value || 0);
    return Number.isFinite(cents) ? Math.max(0, cents) : 0;
  }

  function getLineFinalPriceCents(item) {
    return normalizeCents(item && item.final_line_price);
  }

  function getLineOriginalPriceCents(item) {
    return getLineFinalPriceCents(item);
  }

  function getCartOriginalSubtotalCents(cart) {
    if (cart && cart.items && cart.items.length) {
      return cart.items.reduce(function (sum, item) {
        return sum + getLineOriginalPriceCents(item);
      }, 0);
    }

    return normalizeCents(cart && (cart.original_total_price || cart.items_subtotal_price || cart.total_price));
  }

  // Per-line trade discount, computed from the real Shopify line price. This
  // only changes display; the checkout discount does the actual price change.
  function getLineTradeDiscountCents(item) {
    if (!isTradeMember()) return 0;

    var finalLinePrice = getLineFinalPriceCents(item);
    return Math.round(finalLinePrice * getTradeDiscountRate());
  }

  function getDisplayLinePriceCents(item) {
    return Math.max(0, getLineFinalPriceCents(item) - getLineTradeDiscountCents(item));
  }

  // Sum the per-line discounts so the summary reconciles exactly with the lines
  // (avoids the "discount applied twice" bug from re-subtracting on the total).
  function getTradeDiscountCents(cart) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (sum, item) {
      return sum + getLineTradeDiscountCents(item);
    }, 0);
  }

  function getDisplayCartTotalCents(cart) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (sum, item) {
      return sum + getDisplayLinePriceCents(item);
    }, 0);
  }

  function formatPercentLabel(value) {
    var percent = Number(value) * 100;
    if (!Number.isFinite(percent)) return '';
    return (percent % 1 === 0 ? percent.toFixed(0) : percent.toFixed(2).replace(/0+$/, '').replace(/\.$/, '')) + '%';
  }

  function renderCartPagePriceHtml(originalLinePrice, displayedLinePrice, lineTradeDiscount) {
    if (lineTradeDiscount <= 0) {
      return '<span>' + formatCurrency(displayedLinePrice / 100) + '</span>';
    }

    return [
      '<span class="everhem-cart__item-price-compare">' + formatCurrency(originalLinePrice / 100) + '</span>',
      '<span>' + formatCurrency(displayedLinePrice / 100) + '</span>',
      '<span class="everhem-cart__item-price-tradetag">Trade ' + formatPercentLabel(getTradeDiscountRate()) + '</span>'
    ].join('');
  }

  function enhanceCartPageTradePricing(form) {
    var priceNodes = Array.from(form.querySelectorAll('[data-cart-page-item-price]'));
    if (!priceNodes.length) return;

    var subtotalCents = 0;
    var totalCents = 0;
    var tradeDiscountCents = 0;

    priceNodes.forEach(function (node) {
      var item = {
        final_line_price: node.getAttribute('data-final-line-price'),
        original_line_price: node.getAttribute('data-original-line-price')
      };
      var originalLinePrice = getLineOriginalPriceCents(item);
      var displayedLinePrice = getDisplayLinePriceCents(item);
      var lineTradeDiscount = getLineTradeDiscountCents(item);

      subtotalCents += originalLinePrice;
      totalCents += displayedLinePrice;
      tradeDiscountCents += lineTradeDiscount;
      node.innerHTML = renderCartPagePriceHtml(originalLinePrice, displayedLinePrice, lineTradeDiscount);
    });

    var subtotalValue = form.querySelector('[data-cart-page-subtotal-value]');
    var tradeRow = form.querySelector('[data-cart-page-trade-row]');
    var tradeLabel = form.querySelector('[data-cart-page-trade-label]');
    var tradeValue = form.querySelector('[data-cart-page-trade-value]');
    var totalLabel = form.querySelector('[data-cart-page-total-label]');
    var totalValue = form.querySelector('[data-cart-page-total-value]');
    var tradeNote = form.querySelector('[data-cart-page-trade-note]');

    if (tradeDiscountCents > 0) {
      if (subtotalValue) subtotalValue.textContent = formatCurrency(subtotalCents / 100);
      if (tradeLabel) tradeLabel.textContent = 'Trade savings (' + formatPercentLabel(getTradeDiscountRate()) + ')';
      if (tradeValue) tradeValue.textContent = '-' + formatCurrency(tradeDiscountCents / 100);
      if (tradeRow) tradeRow.hidden = false;
      if (totalLabel) totalLabel.textContent = 'Estimated total';
      if (totalValue) totalValue.textContent = formatCurrency(totalCents / 100);
      if (tradeNote) tradeNote.hidden = false;
      return;
    }

    var cartTotalPrice = subtotalValue ? normalizeCents(subtotalValue.getAttribute('data-cart-total-price')) : totalCents;
    if (subtotalValue) subtotalValue.textContent = formatCurrency(cartTotalPrice / 100);
    if (tradeRow) tradeRow.hidden = true;
    if (totalLabel) totalLabel.textContent = 'Total';
    if (totalValue) totalValue.textContent = formatCurrency(cartTotalPrice / 100);
    if (tradeNote) tradeNote.hidden = true;
  }

  function isHiddenCartProperty(key, value) {
    if (!value) return true;
    if (String(value).indexOf('_bundle_') === 0) return true;
    if (String(key || '').indexOf('_everhem_') === 0) return true;
    return false;
  }

  function renderCartProperty(property) {
    if (!property) return '';
    var key = property[0];
    var value = property[1];

    if (isHiddenCartProperty(key, value)) {
      return '';
    }

    return '<li class="everhem-cart-drawer__property"><span class="everhem-cart-drawer__property-key">' + escapeHtml(key) + ':</span><span>' + escapeHtml(value) + '</span></li>';
  }

  function buildLegacyCartActionUrl(item, mode) {
    var properties = item && item.properties ? item.properties : {};
    return buildLegacyCartActionUrlFromData(
      properties._everhem_edit_product,
      properties._everhem_edit_query,
      properties._everhem_edit_mode,
      mode
    );
  }

  function buildLegacyCartActionUrlFromData(product, query, editMode, mode) {
    if (!product || !query || editMode !== 'legacy-configurator') {
      return '';
    }

    var params = new URLSearchParams(String(query));
    if (mode === 'duplicate') {
      params.delete('itemId');
    }

    return '/pages/' + encodeURIComponent(product) + '?' + params.toString();
  }

  function renderCartItemActions(item) {
    var editUrl = buildLegacyCartActionUrl(item, 'edit');
    var duplicateUrl = buildLegacyCartActionUrl(item, 'duplicate');
    var actions = [];

    if (editUrl) {
      actions.push('<a class="everhem-cart-drawer__action-link" href="' + escapeHtml(editUrl) + '">Edit</a>');
    }

    if (duplicateUrl) {
      actions.push('<a class="everhem-cart-drawer__action-link" href="' + escapeHtml(duplicateUrl) + '">Build Another</a>');
    }

    if (!actions.length) {
      return '';
    }

    return '<div class="everhem-cart-drawer__action-links">' + actions.join('') + '</div>';
  }

  function renderCartQuantityControls(item) {
    return [
      '<div class="everhem-cart-drawer__qty-controls">',
      '<button type="button" class="everhem-cart-drawer__qty-btn" data-cart-quantity-change data-line-key="' + escapeHtml(item.key) + '" data-quantity="' + escapeHtml(Math.max(0, (Number(item.quantity) || 0) - 1)) + '" aria-label="Decrease quantity">−</button>',
      '<span class="everhem-cart-drawer__qty-value">' + escapeHtml(item.quantity) + '</span>',
      '<button type="button" class="everhem-cart-drawer__qty-btn" data-cart-quantity-change data-line-key="' + escapeHtml(item.key) + '" data-quantity="' + escapeHtml((Number(item.quantity) || 0) + 1) + '" aria-label="Increase quantity">+</button>',
      '</div>'
    ].join('');
  }

  function renderCartItem(item) {
    var properties = Object.entries(item.properties || {}).map(renderCartProperty).filter(Boolean).join('');
    var image = item.featured_image && item.featured_image.url
      ? '<img class="everhem-cart-drawer__image" src="' + escapeHtml(item.featured_image.url) + '" alt="' + escapeHtml(item.product_title || item.title || 'Cart item') + '">'
      : '<div class="everhem-cart-drawer__image-placeholder"></div>';
    var originalLinePrice = getLineOriginalPriceCents(item);
    var displayedLinePrice = getDisplayLinePriceCents(item);
    var lineTradeDiscount = getLineTradeDiscountCents(item);
    var comparePriceHtml = lineTradeDiscount > 0
      ? '<span class="everhem-cart-drawer__item-price-compare">' + formatCurrency(originalLinePrice / 100) + '</span>'
      : '';
    var tradeTagHtml = lineTradeDiscount > 0
      ? '<span class="everhem-cart-drawer__item-price-tradetag">Trade ' + formatPercentLabel(getTradeDiscountRate()) + '</span>'
      : '';

    var props = item.properties || {};
    var designSpecs = ['Fabric', 'Lining', 'Hardware Finish', 'Mount Position']
      .map(function (key) { return props[key] || ''; })
      .filter(Boolean)
      .join(', ');

    var windowParts = [];
    if (props['Window Width']) windowParts.push('W: ' + props['Window Width']);
    if (props['Window Height']) windowParts.push('H: ' + props['Window Height']);
    if (props['Mounting Height']) windowParts.push('Mount: ' + props['Mounting Height']);
    var windowSpecs = windowParts.join(' \xB7 ');

    return [
      '<article class="everhem-cart-drawer__item">',
      image,
      '<div>',
      '<h3 class="everhem-cart-drawer__item-title">' + ((item.product_type || '').toLowerCase() === 'swatch' ? '<a href="/pages/samples">' + escapeHtml(item.product_title || item.title || 'Cart item') + '</a>' : escapeHtml(item.product_title || item.title || 'Cart item')) + '</h3>',
      '<p class="everhem-cart-drawer__meta">Qty ' + escapeHtml(item.quantity) + '</p>',
      designSpecs ? '<p class="everhem-cart-drawer__design-specs">' + escapeHtml(designSpecs) + '</p>' : '',
      windowSpecs ? '<p class="everhem-cart-drawer__window-specs">' + escapeHtml(windowSpecs) + '</p>' : '',
      renderCartItemActions(item),
      '<div class="everhem-cart-drawer__item-footer">',
      '<span class="everhem-cart-drawer__item-price">' + comparePriceHtml + formatCurrency(displayedLinePrice / 100) + tradeTagHtml + '</span>',
      '<div class="everhem-cart-drawer__item-controls">',
      renderCartQuantityControls(item),
      '<button type="button" class="everhem-cart-drawer__remove" data-cart-remove data-line-key="' + escapeHtml(item.key) + '">Remove</button>',
      '</div>',
      '</div>',
      '</div>',
      '</article>'
    ].join('');
  }

  function renderCartDrawer(cart) {
    var content = document.querySelector('[data-cart-drawer-content]');
    if (!content) return;

    var emptyCartLabel = window.EverhemTheme && window.EverhemTheme.settings && window.EverhemTheme.settings.emptyCartCtaLabel
      ? String(window.EverhemTheme.settings.emptyCartCtaLabel)
      : 'Continue shopping';
    var emptyCartUrl = window.EverhemTheme && window.EverhemTheme.settings && window.EverhemTheme.settings.emptyCartCtaUrl
      ? String(window.EverhemTheme.settings.emptyCartCtaUrl)
      : '/';

    setCartCount(cart && cart.item_count ? cart.item_count : 0);

    if (!cart || !cart.items || !cart.items.length) {
      content.innerHTML = [
        '<div class="everhem-cart-drawer__empty">',
        '<h3 class="everhem-cart-drawer__empty-title">Your cart is empty.</h3>',
        '<p class="everhem-cart-drawer__empty-copy">Add a configured product or quote to see it here.</p>',
        '<div class="everhem-cart-drawer__actions">',
        '<a class="everhem-cart-drawer__button everhem-cart-drawer__button--secondary" href="' + escapeHtml(emptyCartUrl) + '">' + escapeHtml(emptyCartLabel) + '</a>',
        '</div>',
        '</div>'
      ].join('');
      return;
    }

    var tradeDiscount = getTradeDiscountCents(cart);
    var showTradeDiscount = tradeDiscount > 0;
    var subtotalCents = showTradeDiscount ? getCartOriginalSubtotalCents(cart) : normalizeCents(cart && cart.total_price);
    // Total is the SUM of displayed (discounted) lines so it reconciles with them.
    var totalValue = showTradeDiscount ? getDisplayCartTotalCents(cart) : subtotalCents;
    var totalLabel = showTradeDiscount ? 'Estimated total' : 'Subtotal';
    var ratePct = formatPercentLabel(getTradeDiscountRate());

    content.innerHTML = [
      '<div class="everhem-cart-drawer__items-wrap">',
      '<div class="everhem-cart-drawer__items">',
      cart.items.map(renderCartItem).join(''),
      '</div>',
      '</div>',
      '<div class="everhem-cart-drawer__footer">',
      showTradeDiscount ? '<div class="everhem-cart-drawer__subtotal"><span>Subtotal</span><span class="everhem-cart-drawer__subtotal-value">' + formatCurrency(subtotalCents / 100) + '</span></div>' : '',
      showTradeDiscount ? '<div class="everhem-cart-drawer__subtotal everhem-cart-drawer__subtotal--discount"><span>Trade savings (' + ratePct + ')</span><span class="everhem-cart-drawer__subtotal-value">\u2212' + formatCurrency(tradeDiscount / 100) + '</span></div>' : '',
      '<div class="everhem-cart-drawer__subtotal"><span>' + totalLabel + '</span><span class="everhem-cart-drawer__subtotal-value">' + formatCurrency(totalValue / 100) + '</span></div>',
      showTradeDiscount ? '<p class="everhem-cart-drawer__note">Trade pricing is an estimate. Your ' + ratePct + ' trade discount is applied to your order at checkout while logged into an approved trade account.</p>' : '',
      '<p class="everhem-cart-drawer__note">Shipping and taxes calculated at checkout.</p>',
      '<div class="everhem-cart-drawer__actions">',
      '<a class="everhem-cart-drawer__button" href="/checkout" data-everhem-begin-checkout>Checkout</a>',
      '<a class="everhem-cart-drawer__button everhem-cart-drawer__button--secondary" href="/cart">View cart</a>',
      '</div>',
      '</div>'
    ].join('');
  }

  function renderCartDrawerWithTradeState(cart) {
    return resolveTradeMembership().then(function () {
      renderCartDrawer(cart);
      return cart;
    }).catch(function () {
      renderCartDrawer(cart);
      return cart;
    });
  }

  var cartDrawerCloseTimer = null;

  function openCartDrawer() {
    var root = getCartDrawerRoot();
    if (!root) return;

    if (cartDrawerCloseTimer) {
      window.clearTimeout(cartDrawerCloseTimer);
      cartDrawerCloseTimer = null;
    }

    root.hidden = false;
    requestAnimationFrame(function () {
      root.classList.add('is-open');
    });
    document.body.classList.add('everhem-cart-drawer-open');
    var panel = root.querySelector('.everhem-cart-drawer__panel');
    if (panel) {
      panel.setAttribute('aria-hidden', 'false');
    }
  }

  function closeCartDrawer() {
    var root = getCartDrawerRoot();
    if (!root) return;
    root.classList.remove('is-open');
    document.body.classList.remove('everhem-cart-drawer-open');
    var panel = root.querySelector('.everhem-cart-drawer__panel');
    if (panel) {
      panel.setAttribute('aria-hidden', 'true');
    }
    cartDrawerCloseTimer = window.setTimeout(function () {
      if (!root.classList.contains('is-open')) {
        root.hidden = true;
      }
      cartDrawerCloseTimer = null;
    }, 280);
  }

  function refreshCartDrawer(options) {
    return fetchCart().then(function (cart) {
      return renderCartDrawerWithTradeState(cart).then(function () {
        if (!options || options.open !== false) {
          openCartDrawer();
        }
        return cart;
      });
    });
  }

  function handleExternalCartAdded() {
    setCartStatus('Added to cart.', false);
    return refreshCartDrawer({ open: true }).then(function (cart) {
      setCartCount(cart && typeof cart.item_count !== 'undefined' ? cart.item_count : 0);
      return cart;
    }).catch(function (error) {
      setCartStatus(error && error.message ? error.message : 'Added to cart.', false);
      openCartDrawer();
      throw error;
    });
  }

  window.EverhemTheme.handleExternalCartAdded = handleExternalCartAdded;

  window.addEventListener('everhem:cart-added', function () {
    handleExternalCartAdded().catch(function () {});
  });

  function bindDynamicFabricRows() {
    function handleDynamicFabricTrigger(target) {
      var button = target.closest('[data-everhem-fabric-swatch]');
      if (!button || button.disabled) return;

      var variantId = button.getAttribute('data-variant-id');
      if (!variantId) return;

      var nameNode = button.querySelector('.everhem-fabrics__swatch-name');
      var originalLabel = nameNode ? nameNode.textContent : '';
      button.disabled = true;
      button.classList.add('is-adding');
      if (nameNode) nameNode.textContent = 'Adding…';
      setCartStatus('Adding swatch…', false);

      addToCart({
        id: parseInt(variantId, 10),
        quantity: 1
      }).then(function (item) {
        trackAddToCart('swatch', item, {
          variantId: variantId,
          title: originalLabel,
          productType: 'Swatch',
          sku: button.getAttribute('data-variant-sku') || '',
          price: centsToAnalyticsValue(button.getAttribute('data-price') || 0),
          fabric: originalLabel,
          fabricSku: button.getAttribute('data-variant-sku') || '',
          quantity: 1,
        });
        return refreshCartDrawer({ open: true });
      }).then(function (cart) {
        setCartCount(cart && typeof cart.item_count !== 'undefined' ? cart.item_count : 0);
        setCartStatus('Added to cart.', false);
      }).catch(function (error) {
        setCartStatus(error && error.message ? error.message : 'Could not add that swatch right now.', true);
        openCartDrawer();
      }).finally(function () {
        button.disabled = false;
        button.classList.remove('is-adding');
        if (nameNode) nameNode.textContent = originalLabel;
      });
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-everhem-fabric-swatch]');
      if (!trigger) return;
      event.preventDefault();
      handleDynamicFabricTrigger(trigger);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var trigger = event.target.closest('[data-everhem-fabric-swatch]');
      if (!trigger) return;
      event.preventDefault();
      handleDynamicFabricTrigger(trigger);
    });
  }

  function bindCartDrawer() {
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-cart-toggle]');
      if (toggle) {
        event.preventDefault();
        setCartStatus('', false);
        refreshCartDrawer();
        return;
      }

      var close = event.target.closest('[data-cart-drawer-close]');
      if (close) {
        event.preventDefault();
        closeCartDrawer();
        return;
      }

      var quantityChange = event.target.closest('[data-cart-quantity-change]');
      if (quantityChange) {
        event.preventDefault();
        var nextQuantity = Math.max(0, Number(quantityChange.getAttribute('data-quantity')) || 0);
        setCartStatus(nextQuantity === 0 ? 'Removing item…' : 'Updating quantity…', false);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: quantityChange.getAttribute('data-line-key'),
            quantity: nextQuantity
          })
        }).then(function (response) {
          return parseJsonResponse(response, nextQuantity === 0 ? 'Failed to remove item' : 'Failed to update quantity');
        }).then(function (cart) {
          setCartStatus('', false);
          return renderCartDrawerWithTradeState(cart).then(function () {
            openCartDrawer();
          });
        }).catch(function (error) {
          setCartStatus(error && error.message ? error.message : (nextQuantity === 0 ? 'Failed to remove item' : 'Failed to update quantity'), true);
          openCartDrawer();
        });
        return;
      }

      var remove = event.target.closest('[data-cart-remove]');
      if (remove) {
        event.preventDefault();
        setCartStatus('Removing item…', false);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: remove.getAttribute('data-line-key'),
            quantity: 0
          })
        }).then(function (response) {
          return parseJsonResponse(response, 'Failed to remove item');
        }).then(function (cart) {
          setCartStatus('', false);
          return renderCartDrawerWithTradeState(cart).then(function () {
            openCartDrawer();
          });
        }).catch(function (error) {
          setCartStatus(error && error.message ? error.message : 'Failed to remove item', true);
          openCartDrawer();
        });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeCartDrawer();
      }
    });

    refreshCartDrawer({ open: false }).catch(function () {
      setCartCount(0);
    });
  }

  function continueToCheckout(trigger) {
    if (!trigger) {
      window.location.href = '/checkout';
      return;
    }

    var form = trigger.form || trigger.closest('form');
    if (form) {
      var checkoutInput = form.querySelector('input[name="checkout"][type="hidden"]');
      if (!checkoutInput) {
        checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutInput.value = trigger.value || 'Checkout';
        form.appendChild(checkoutInput);
      }
      form.submit();
      return;
    }

    window.location.href = trigger.href || '/checkout';
  }

  function bindBeginCheckoutTracking() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-everhem-begin-checkout]');
      if (!trigger || trigger.dataset.checkoutTrackingStarted === 'true') return;

      event.preventDefault();
      trigger.dataset.checkoutTrackingStarted = 'true';

      fetchCart().then(function (cart) {
        trackBeginCheckout(cart);
      }).catch(function () {
        trackBeginCheckout(null);
      }).finally(function () {
        continueToCheckout(trigger);
      });
    });
  }

  function bindCartPage() {
    var form = document.querySelector('[data-cart-page-form]');
    if (!form) return;

    var submitTimer = null;
    var submitButtonSelector = 'button[name="update"], input[name="update"], .everhem-cart__update';

    function normalizeQuantityValue(input) {
      if (!input) return 0;
      var nextValue = Number(input.value || 0);
      var normalized = Number.isFinite(nextValue) ? Math.max(0, Math.round(nextValue)) : 0;
      input.value = String(normalized);
      return normalized;
    }

    function requestCartSubmit(immediate) {
      if (submitTimer) {
        window.clearTimeout(submitTimer);
        submitTimer = null;
      }

      var triggerSubmit = function () {
        submitTimer = null;
        var submitButton = form.querySelector(submitButtonSelector);
        if (submitButton && typeof submitButton.click === 'function') {
          submitButton.click();
          return;
        }

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
          return;
        }

        form.submit();
      };

      if (immediate) {
        triggerSubmit();
        return;
      }

      submitTimer = window.setTimeout(triggerSubmit, 180);
    }

    form.querySelectorAll('[data-cart-page-actions]').forEach(function (node) {
      var editUrl = buildLegacyCartActionUrlFromData(
        node.getAttribute('data-edit-product'),
        node.getAttribute('data-edit-query'),
        node.getAttribute('data-edit-mode'),
        'edit'
      );
      var duplicateUrl = buildLegacyCartActionUrlFromData(
        node.getAttribute('data-edit-product'),
        node.getAttribute('data-edit-query'),
        node.getAttribute('data-edit-mode'),
        'duplicate'
      );
      var actions = [];

      if (editUrl) {
        actions.push('<a class="everhem-cart__action-link" href="' + escapeHtml(editUrl) + '">Edit</a>');
      }

      if (duplicateUrl) {
        actions.push('<a class="everhem-cart__action-link" href="' + escapeHtml(duplicateUrl) + '">Build Another</a>');
      }

      if (actions.length) {
        node.innerHTML = actions.join('');
        node.hidden = false;
      }
    });

    resolveTradeMembership().then(function () {
      enhanceCartPageTradePricing(form);
    }).catch(function () {
      enhanceCartPageTradePricing(form);
    });

    form.addEventListener('click', function (event) {
      var button = event.target.closest('[data-cart-page-quantity-change]');
      if (!button) return;

      event.preventDefault();
      var targetId = button.getAttribute('data-target');
      var input = targetId ? document.getElementById(targetId) : null;
      if (!input) return;

      var nextValue = normalizeQuantityValue(input) + Number(button.getAttribute('data-step') || 0);
      input.value = String(Math.max(0, nextValue));
      requestCartSubmit(true);
    });

    form.addEventListener('change', function (event) {
      var input = event.target.closest('[data-cart-page-quantity-input]');
      if (!input) return;

      normalizeQuantityValue(input);
      requestCartSubmit(false);
    });
  }

  function bindAjaxProductForms() {
    document.querySelectorAll('form.everhem-pdp__form').forEach(function (form) {
      if (form.dataset.ajaxCartBound === 'true') return;
      form.dataset.ajaxCartBound = 'true';

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
        var originalText = submitButton && submitButton.tagName === 'BUTTON' ? submitButton.innerHTML : null;

        if (submitButton) {
          submitButton.disabled = true;
          if (submitButton.tagName === 'BUTTON') {
            submitButton.innerHTML = 'Adding…';
          }
        }

        setCartStatus('Adding item to cart…', false);

        var analyticsFallback = buildProductFormAnalyticsFallback(form);

        addToCart(new window.FormData(form)).then(function (item) {
          trackAddToCart('product', item, analyticsFallback);
          return refreshCartDrawer({ open: true });
        }).then(function (cart) {
          setCartCount(cart && typeof cart.item_count !== 'undefined' ? cart.item_count : 0);
          setCartStatus('Added to cart.', false);
        }).catch(function (error) {
          setCartStatus(error && error.message ? error.message : 'Failed to add item to cart', true);
          openCartDrawer();
        }).finally(function () {
          if (submitButton) {
            submitButton.disabled = false;
            if (submitButton.tagName === 'BUTTON' && originalText != null) {
              submitButton.innerHTML = originalText;
            }
          }
        });
      });
    });
  }

  function safe(fn, label) {
    try { fn(); } catch (e) { console.error('[everhem] ' + label + ' failed:', e); }
  }

  function bootAccountAuthCallback() {
    if (window.location.pathname !== ACCOUNT_AUTH_CALLBACK_PATH) {
      return;
    }

    var params = new URLSearchParams(window.location.search);

    console.log('[everhem account] auth callback boot');
    setCallbackState('Finishing sign-in…', 'Hang tight while we connect your Shopify customer account.', false);

    if (params.get('error')) {
      clearStoredTokens();
      clearStoredAuthState();
      setCallbackState('Sign-in did not complete', params.get('error_description') || 'Shopify sent us back without completing sign-in.', true);
      return;
    }

    ensureCustomerAccountToken().catch(function (error) {
      console.error('[everhem account] auth callback failed', error);
      clearStoredTokens();
      clearStoredAuthState();
      setCallbackState('Could not finish sign-in', error && error.message ? error.message : 'Customer account callback failed.', true);
    });
  }

  window.EverhemTheme.boot = function bootEverhemTheme() {
    document.documentElement.setAttribute('data-js', 'loaded');
    safe(bindToggleClass, 'bindToggleClass');
    safe(bindHeaderScrollState, 'bindHeaderScrollState');
    safe(bindTabs, 'bindTabs');
    safe(bindCarouselArrows, 'bindCarouselArrows');
    safe(bindCarouselDrag, 'bindCarouselDrag');
    safe(bindPdpConfigToggle, 'bindPdpConfigToggle');
    safe(bindPdpCounters, 'bindPdpCounters');
    safe(bindPdpSwatchPicker, 'bindPdpSwatchPicker');
    safe(bindSwatchCollectionCards, 'bindSwatchCollectionCards');
    safe(bindDynamicFabricRows, 'bindDynamicFabricRows');
    safe(bindCollabCarousel, 'bindCollabCarousel');
    safe(bindMobileNav, 'bindMobileNav');
    safe(bindAnnouncementDismiss, 'bindAnnouncementDismiss');
    safe(bindCartDrawer, 'bindCartDrawer');
    safe(bindBeginCheckoutTracking, 'bindBeginCheckoutTracking');
    safe(bindCartPage, 'bindCartPage');
    safe(bindAjaxProductForms, 'bindAjaxProductForms');
    safe(initCustomerAccountConfig, 'initCustomerAccountConfig');
    safe(bindAccountAuthStart, 'bindAccountAuthStart');
    safe(bootAccountAuthCallback, 'bootAccountAuthCallback');
    safe(loadAccountDashboard, 'loadAccountDashboard');
  };

  $(window.EverhemTheme.boot);
})(window.jQuery, window, document);
